const Qt = (e) => {
  const t = e;
  return typeof t.firstName == "string" && typeof t.street == "string" && typeof t.housenumber == "string";
}, j = (e) => ({
  type: "addresses",
  firstName: e.firstName,
  lastName: e.lastName,
  address1: e.address1,
  city: e.city,
  country: e.country,
  fkCountry: e.fkCountry,
  iso2Code: e.iso2Code,
  zipCode: e.zipCode,
  id: e.id ?? void 0,
  isDefaultBilling: e.isDefaultBilling ?? !1,
  isDefaultShipping: e.isDefaultShipping ?? !1,
  address3: e.address3 ?? void 0,
  company: e.company ?? void 0,
  phone: e.phone ?? void 0,
  salutation: e.salutation ?? void 0,
  email: e.email ?? void 0,
  links: e.links ?? void 0
}), er = (e) => Qt(e) ? {
  address1: `${e.street} ${e.housenumber}`,
  city: e.city,
  isDefaultBilling: !1,
  isDefaultShipping: !1,
  firstName: e.firstName,
  lastName: e.lastName,
  zipCode: e.zipCode,
  iso2Code: e.country
} : {
  id: e.id,
  address1: e.address1,
  city: e.city,
  firstName: e.firstName,
  fkCountry: e.fkCountry,
  isDefaultBilling: e.isDefaultBilling,
  isDefaultShipping: e.isDefaultShipping,
  iso2Code: e.iso2Code,
  lastName: e.lastName,
  zipCode: e.zipCode,
  address3: e.address3,
  company: e.company,
  phone: e.phone,
  salutation: e.salutation
};
class Le extends Error {
  constructor(t, r, o) {
    const n = t.status || t.status === 0 ? t.status : "", s = t.statusText || "", i = `${n} ${s}`.trim(), a = i ? `status code ${i}` : "an unknown error";
    super(`Request failed with ${a}`), Object.defineProperty(this, "response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "HTTPError", this.response = t, this.request = r, this.options = o;
  }
}
class st extends Error {
  constructor(t) {
    super("Request timed out"), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "TimeoutError", this.request = t;
  }
}
const $ = (e) => e !== null && typeof e == "object", x = (...e) => {
  for (const t of e)
    if ((!$(t) || Array.isArray(t)) && t !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return de({}, ...e);
}, it = (e = {}, t = {}) => {
  const r = new globalThis.Headers(e), o = t instanceof globalThis.Headers, n = new globalThis.Headers(t);
  for (const [s, i] of n.entries())
    o && i === "undefined" || i === void 0 ? r.delete(s) : r.set(s, i);
  return r;
}, de = (...e) => {
  let t = {}, r = {};
  for (const o of e)
    if (Array.isArray(o))
      Array.isArray(t) || (t = []), t = [...t, ...o];
    else if ($(o)) {
      for (let [n, s] of Object.entries(o))
        $(s) && n in t && (s = de(t[n], s)), t = { ...t, [n]: s };
      $(o.headers) && (r = it(r, o.headers), t.headers = r);
    }
  return t;
}, tr = (() => {
  let e = !1, t = !1;
  const r = typeof globalThis.ReadableStream == "function", o = typeof globalThis.Request == "function";
  return r && o && (t = new globalThis.Request("https://empty.invalid", {
    body: new globalThis.ReadableStream(),
    method: "POST",
    // @ts-expect-error - Types are outdated.
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type")), e && !t;
})(), rr = typeof globalThis.AbortController == "function", or = typeof globalThis.ReadableStream == "function", nr = typeof globalThis.FormData == "function", at = ["get", "post", "put", "patch", "head", "delete"], sr = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, te = 2147483647, ct = Symbol("stop"), ir = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  fetch: !0
}, ar = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, cr = (e) => at.includes(e) ? e.toUpperCase() : e, lr = ["get", "put", "head", "delete", "options", "trace"], dr = [408, 413, 429, 500, 502, 503, 504], lt = [413, 429, 503], ze = {
  limit: 2,
  methods: lr,
  statusCodes: dr,
  afterStatusCodes: lt,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (e) => 0.3 * 2 ** (e - 1) * 1e3
}, ur = (e = {}) => {
  if (typeof e == "number")
    return {
      ...ze,
      limit: e
    };
  if (e.methods && !Array.isArray(e.methods))
    throw new Error("retry.methods must be an array");
  if (e.statusCodes && !Array.isArray(e.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...ze,
    ...e,
    afterStatusCodes: lt
  };
};
async function pr(e, t, r, o) {
  return new Promise((n, s) => {
    const i = setTimeout(() => {
      r && r.abort(), s(new st(e));
    }, o.timeout);
    o.fetch(e, t).then(n).catch(s).then(() => {
      clearTimeout(i);
    });
  });
}
async function fr(e, { signal: t }) {
  return new Promise((r, o) => {
    t && (t.throwIfAborted(), t.addEventListener("abort", n, { once: !0 }));
    function n() {
      clearTimeout(s), o(t.reason);
    }
    const s = setTimeout(() => {
      t == null || t.removeEventListener("abort", n), r();
    }, e);
  });
}
const hr = (e, t) => {
  const r = {};
  for (const o in t)
    !(o in ar) && !(o in ir) && !(o in e) && (r[o] = t[o]);
  return r;
};
class H {
  static create(t, r) {
    const o = new H(t, r), n = async () => {
      if (typeof o._options.timeout == "number" && o._options.timeout > te)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${te}`);
      await Promise.resolve();
      let a = await o._fetch();
      for (const c of o._options.hooks.afterResponse) {
        const l = await c(o.request, o._options, o._decorateResponse(a.clone()));
        l instanceof globalThis.Response && (a = l);
      }
      if (o._decorateResponse(a), !a.ok && o._options.throwHttpErrors) {
        let c = new Le(a, o.request, o._options);
        for (const l of o._options.hooks.beforeError)
          c = await l(c);
        throw c;
      }
      if (o._options.onDownloadProgress) {
        if (typeof o._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!or)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return o._stream(a.clone(), o._options.onDownloadProgress);
      }
      return a;
    }, i = o._options.retry.methods.includes(o.request.method.toLowerCase()) ? o._retry(n) : n();
    for (const [a, c] of Object.entries(sr))
      i[a] = async () => {
        o.request.headers.set("accept", o.request.headers.get("accept") || c);
        const d = (await i).clone();
        if (a === "json") {
          if (d.status === 204 || (await d.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (r.parseJson)
            return r.parseJson(await d.text());
        }
        return d[a]();
      };
    return i;
  }
  // eslint-disable-next-line complexity
  constructor(t, r = {}) {
    var n, s;
    Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "abortController", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "_input", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._input = t;
    const o = this._input instanceof Request && "credentials" in Request.prototype ? this._input.credentials : void 0;
    if (this._options = {
      ...o && { credentials: o },
      // For exactOptionalPropertyTypes
      ...r,
      headers: it(this._input.headers, r.headers),
      hooks: de({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, r.hooks),
      method: cr(r.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(r.prefixUrl || ""),
      retry: ur(r.retry),
      throwHttpErrors: r.throwHttpErrors !== !1,
      timeout: r.timeout ?? 1e4,
      fetch: r.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (rr) {
      if (this.abortController = new globalThis.AbortController(), this._options.signal) {
        const i = this._options.signal;
        this._options.signal.addEventListener("abort", () => {
          this.abortController.abort(i.reason);
        });
      }
      this._options.signal = this.abortController.signal;
    }
    if (tr && (this._options.duplex = "half"), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const a = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), c = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, a);
      (nr && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(c, { ...this.request }), this._options);
    }
    this._options.json !== void 0 && (this._options.body = ((s = (n = this._options).stringifyJson) == null ? void 0 : s.call(n, this._options.json)) ?? JSON.stringify(this._options.json), this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json"), this.request = new globalThis.Request(this.request, { body: this._options.body }));
  }
  _calculateRetryDelay(t) {
    if (this._retryCount++, this._retryCount <= this._options.retry.limit && !(t instanceof st)) {
      if (t instanceof Le) {
        if (!this._options.retry.statusCodes.includes(t.response.status))
          return 0;
        const o = t.response.headers.get("Retry-After");
        if (o && this._options.retry.afterStatusCodes.includes(t.response.status)) {
          let n = Number(o);
          return Number.isNaN(n) ? n = Date.parse(o) - Date.now() : n *= 1e3, this._options.retry.maxRetryAfter !== void 0 && n > this._options.retry.maxRetryAfter ? 0 : n;
        }
        if (t.response.status === 413)
          return 0;
      }
      const r = this._options.retry.delay(this._retryCount);
      return Math.min(this._options.retry.backoffLimit, r);
    }
    return 0;
  }
  _decorateResponse(t) {
    return this._options.parseJson && (t.json = async () => this._options.parseJson(await t.text())), t;
  }
  async _retry(t) {
    try {
      return await t();
    } catch (r) {
      const o = Math.min(this._calculateRetryDelay(r), te);
      if (o !== 0 && this._retryCount > 0) {
        await fr(o, { signal: this._options.signal });
        for (const n of this._options.hooks.beforeRetry)
          if (await n({
            request: this.request,
            options: this._options,
            error: r,
            retryCount: this._retryCount
          }) === ct)
            return;
        return this._retry(t);
      }
      throw r;
    }
  }
  async _fetch() {
    for (const r of this._options.hooks.beforeRequest) {
      const o = await r(this.request, this._options);
      if (o instanceof Request) {
        this.request = o;
        break;
      }
      if (o instanceof Response)
        return o;
    }
    const t = hr(this.request, this._options);
    return this._options.timeout === !1 ? this._options.fetch(this.request.clone(), t) : pr(this.request.clone(), t, this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(t, r) {
    const o = Number(t.headers.get("content-length")) || 0;
    let n = 0;
    return t.status === 204 ? (r && r({ percent: 1, totalBytes: o, transferredBytes: n }, new Uint8Array()), new globalThis.Response(null, {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(s) {
        const i = t.body.getReader();
        r && r({ percent: 0, transferredBytes: 0, totalBytes: o }, new Uint8Array());
        async function a() {
          const { done: c, value: l } = await i.read();
          if (c) {
            s.close();
            return;
          }
          if (r) {
            n += l.byteLength;
            const d = o === 0 ? 0 : n / o;
            r({ percent: d, transferredBytes: n, totalBytes: o }, l);
          }
          s.enqueue(l), await a();
        }
        await a();
      }
    }), {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const se = (e) => {
  const t = (r, o) => H.create(r, x(e, o));
  for (const r of at)
    t[r] = (o, n) => H.create(o, x(e, n, { method: r }));
  return t.create = (r) => se(x(r)), t.extend = (r) => se(x(e, r)), t.stop = ct, t;
}, yr = se();
/*! js-cookie v3.0.5 | MIT */
function U(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var o in r)
      e[o] = r[o];
  }
  return e;
}
var mr = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function ie(e, t) {
  function r(n, s, i) {
    if (!(typeof document > "u")) {
      i = U({}, t, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";
      for (var c in i)
        i[c] && (a += "; " + c, i[c] !== !0 && (a += "=" + i[c].split(";")[0]));
      return document.cookie = n + "=" + e.write(s, n) + a;
    }
  }
  function o(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], i = {}, a = 0; a < s.length; a++) {
        var c = s[a].split("="), l = c.slice(1).join("=");
        try {
          var d = decodeURIComponent(c[0]);
          if (i[d] = e.read(l, d), n === d)
            break;
        } catch {
        }
      }
      return n ? i[n] : i;
    }
  }
  return Object.create(
    {
      set: r,
      get: o,
      remove: function(n, s) {
        r(
          n,
          "",
          U({}, s, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return ie(this.converter, U({}, this.attributes, n));
      },
      withConverter: function(n) {
        return ie(U({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var dt = ie(mr, { path: "/" });
const ut = () => typeof window < "u" && typeof window.document < "u", Z = () => !ut(), gr = (e) => e.startsWith("beta"), _r = () => dt.get("IS_CANARY") === "true", vr = () => dt.get("fondof_internal") === "true", wr = (e) => e.includes("dev.") || e.includes("localhost"), pt = {
  de: "de",
  dk: "da",
  en: "en",
  it: "it",
  es: "es",
  fr: "fr"
}, Rr = "en", Pr = Object.keys(pt), Ir = ["de"], Ar = (e) => Pr.includes(e), ft = (e) => {
  var t;
  const r = ((t = globalThis.location) == null ? void 0 : t.origin) ?? "";
  return Ir.find(
    (o) => r.endsWith(`.${o}`)
  );
}, Dr = (e) => {
  var t;
  const r = ((t = globalThis.location) == null ? void 0 : t.pathname) ?? "", [o, n] = r.split("/");
  return n;
}, Or = () => ft() ? "/" : `/${ht()}`, ht = () => {
  const e = ft(), t = Dr();
  return e || (Ar(t) ? t : Rr);
}, Tr = () => pt[ht()], Cr = () => {
  if (Z())
    return {
      set: () => !0,
      get: () => null,
      delete: () => null
    };
  const e = {};
  return e.set = (t, r) => {
    try {
      window.localStorage.setItem(t, r);
    } catch {
      return !1;
    }
    return !0;
  }, e.get = (t) => window.localStorage.getItem(t), e.delete = (t) => {
    window.localStorage.removeItem(t);
  }, e;
}, br = () => {
  if (Z())
    return {
      set: () => !0,
      get: () => null,
      delete: () => null
    };
  const e = {};
  return e.set = (t, r) => {
    try {
      window.sessionStorage.setItem(t, r);
    } catch {
      return !1;
    }
    return !0;
  }, e.get = (t) => window.sessionStorage.getItem(t), e.delete = (t) => {
    window.sessionStorage.removeItem(t);
  }, e;
}, Er = (e) => {
  switch (e) {
    case "localStorage":
      return Cr();
    case "sessionStorage":
      return br();
  }
}, yt = {
  create: (e) => Er(e)
};
function ae(e) {
  this.message = e;
}
ae.prototype = new Error(), ae.prototype.name = "InvalidCharacterError";
var qe = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new ae("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, o, n = 0, s = 0, i = ""; o = t.charAt(s++); ~o && (r = n % 4 ? 64 * r + o : o, n++ % 4) ? i += String.fromCharCode(255 & r >> (-2 * n & 6)) : 0) o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
  return i;
};
function Sr(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(r) {
      return decodeURIComponent(qe(r).replace(/(.)/g, function(o, n) {
        var s = n.charCodeAt(0).toString(16).toUpperCase();
        return s.length < 2 && (s = "0" + s), "%" + s;
      }));
    }(t);
  } catch {
    return qe(t);
  }
}
function V(e) {
  this.message = e;
}
function jr(e, t) {
  if (typeof e != "string") throw new V("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(Sr(e.split(".")[r]));
  } catch (o) {
    throw new V("Invalid token specified: " + o.message);
  }
}
V.prototype = new Error(), V.prototype.name = "InvalidTokenError";
const Mr = (e) => {
  if (Z())
    return null;
  const t = new URLSearchParams(window.location.search);
  return t.has(e) ? t.get(e) : null;
}, mt = "TOKEN_STORAGE_KEY", kr = "signature", xr = "uuid", Ur = "cart", Lr = "checkoutAddress", zr = "checkoutSuccess", qr = "checkoutPayment", Nr = "triggerBeginCheckout", Br = "loginConfirmed", Fr = "guestLoginConfirmed", $r = "blocked", Jr = "hideWelcomeBack", Hr = "selectedPaymentMethod", P = yt.create("localStorage"), Vr = () => {
  if (!P)
    throw new Error("Storage adapter not found");
  P.delete(mt), P.delete(xr), P.delete(Ur), P.delete(zr), P.delete(Lr), P.delete(qr), P.delete(Hr), sessionStorage.removeItem(Nr), sessionStorage.removeItem(Br), sessionStorage.removeItem(Fr), sessionStorage.removeItem($r), sessionStorage.removeItem(Jr);
}, Gr = () => {
  if (!P)
    throw new Error("Storage adapter not found");
  return P.get(mt) || Mr(kr);
}, Wr = (e) => {
  if (!e)
    return !0;
  const { exp: t } = jr(e);
  return new Date(t * 1e3) < /* @__PURE__ */ new Date();
};
class Ne extends Error {
  constructor(t, r, o) {
    const n = t.status || t.status === 0 ? t.status : "", s = t.statusText || "", i = `${n} ${s}`.trim(), a = i ? `status code ${i}` : "an unknown error";
    super(`Request failed with ${a}`), Object.defineProperty(this, "response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "HTTPError", this.response = t, this.request = r, this.options = o;
  }
}
class gt extends Error {
  constructor(t) {
    super("Request timed out"), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "TimeoutError", this.request = t;
  }
}
const J = (e) => e !== null && typeof e == "object", L = (...e) => {
  for (const t of e)
    if ((!J(t) || Array.isArray(t)) && t !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return ue({}, ...e);
}, _t = (e = {}, t = {}) => {
  const r = new globalThis.Headers(e), o = t instanceof globalThis.Headers, n = new globalThis.Headers(t);
  for (const [s, i] of n.entries())
    o && i === "undefined" || i === void 0 ? r.delete(s) : r.set(s, i);
  return r;
}, ue = (...e) => {
  let t = {}, r = {};
  for (const o of e)
    if (Array.isArray(o))
      Array.isArray(t) || (t = []), t = [...t, ...o];
    else if (J(o)) {
      for (let [n, s] of Object.entries(o))
        J(s) && n in t && (s = ue(t[n], s)), t = { ...t, [n]: s };
      J(o.headers) && (r = _t(r, o.headers), t.headers = r);
    }
  return t;
}, Xr = (() => {
  let e = !1, t = !1;
  const r = typeof globalThis.ReadableStream == "function", o = typeof globalThis.Request == "function";
  return r && o && (t = new globalThis.Request("https://empty.invalid", {
    body: new globalThis.ReadableStream(),
    method: "POST",
    // @ts-expect-error - Types are outdated.
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type")), e && !t;
})(), Kr = typeof globalThis.AbortController == "function", Yr = typeof globalThis.ReadableStream == "function", Zr = typeof globalThis.FormData == "function", vt = ["get", "post", "put", "patch", "head", "delete"], Qr = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, re = 2147483647, wt = Symbol("stop"), eo = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  fetch: !0
}, to = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, ro = (e) => vt.includes(e) ? e.toUpperCase() : e, oo = ["get", "put", "head", "delete", "options", "trace"], no = [408, 413, 429, 500, 502, 503, 504], Rt = [413, 429, 503], Be = {
  limit: 2,
  methods: oo,
  statusCodes: no,
  afterStatusCodes: Rt,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (e) => 0.3 * 2 ** (e - 1) * 1e3
}, so = (e = {}) => {
  if (typeof e == "number")
    return {
      ...Be,
      limit: e
    };
  if (e.methods && !Array.isArray(e.methods))
    throw new Error("retry.methods must be an array");
  if (e.statusCodes && !Array.isArray(e.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...Be,
    ...e,
    afterStatusCodes: Rt
  };
};
async function io(e, t, r, o) {
  return new Promise((n, s) => {
    const i = setTimeout(() => {
      r && r.abort(), s(new gt(e));
    }, o.timeout);
    o.fetch(e, t).then(n).catch(s).then(() => {
      clearTimeout(i);
    });
  });
}
async function ao(e, { signal: t }) {
  return new Promise((r, o) => {
    t && (t.throwIfAborted(), t.addEventListener("abort", n, { once: !0 }));
    function n() {
      clearTimeout(s), o(t.reason);
    }
    const s = setTimeout(() => {
      t == null || t.removeEventListener("abort", n), r();
    }, e);
  });
}
const co = (e, t) => {
  const r = {};
  for (const o in t)
    !(o in to) && !(o in eo) && !(o in e) && (r[o] = t[o]);
  return r;
};
class G {
  static create(t, r) {
    const o = new G(t, r), n = async () => {
      if (typeof o._options.timeout == "number" && o._options.timeout > re)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${re}`);
      await Promise.resolve();
      let i = await o._fetch();
      for (const a of o._options.hooks.afterResponse) {
        const c = await a(o.request, o._options, o._decorateResponse(i.clone()));
        c instanceof globalThis.Response && (i = c);
      }
      if (o._decorateResponse(i), !i.ok && o._options.throwHttpErrors) {
        let a = new Ne(i, o.request, o._options);
        for (const c of o._options.hooks.beforeError)
          a = await c(a);
        throw a;
      }
      if (o._options.onDownloadProgress) {
        if (typeof o._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!Yr)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return o._stream(i.clone(), o._options.onDownloadProgress);
      }
      return i;
    }, s = o._options.retry.methods.includes(o.request.method.toLowerCase()) ? o._retry(n) : n();
    for (const [i, a] of Object.entries(Qr))
      s[i] = async () => {
        o.request.headers.set("accept", o.request.headers.get("accept") || a);
        const c = (await s).clone();
        if (i === "json") {
          if (c.status === 204 || (await c.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (r.parseJson)
            return r.parseJson(await c.text());
        }
        return c[i]();
      };
    return s;
  }
  // eslint-disable-next-line complexity
  constructor(t, r = {}) {
    var o, n;
    Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "abortController", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "_input", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._input = t;
    const s = this._input instanceof Request && "credentials" in Request.prototype ? this._input.credentials : void 0;
    if (this._options = {
      ...s && { credentials: s },
      // For exactOptionalPropertyTypes
      ...r,
      headers: _t(this._input.headers, r.headers),
      hooks: ue({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, r.hooks),
      method: ro(r.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(r.prefixUrl || ""),
      retry: so(r.retry),
      throwHttpErrors: r.throwHttpErrors !== !1,
      timeout: r.timeout ?? 1e4,
      fetch: r.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (Kr) {
      if (this.abortController = new globalThis.AbortController(), this._options.signal) {
        const i = this._options.signal;
        this._options.signal.addEventListener("abort", () => {
          this.abortController.abort(i.reason);
        });
      }
      this._options.signal = this.abortController.signal;
    }
    if (Xr && (this._options.duplex = "half"), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const i = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), a = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, i);
      (Zr && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(a, { ...this.request }), this._options);
    }
    this._options.json !== void 0 && (this._options.body = ((n = (o = this._options).stringifyJson) == null ? void 0 : n.call(o, this._options.json)) ?? JSON.stringify(this._options.json), this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json"), this.request = new globalThis.Request(this.request, { body: this._options.body }));
  }
  _calculateRetryDelay(t) {
    if (this._retryCount++, this._retryCount <= this._options.retry.limit && !(t instanceof gt)) {
      if (t instanceof Ne) {
        if (!this._options.retry.statusCodes.includes(t.response.status))
          return 0;
        const o = t.response.headers.get("Retry-After");
        if (o && this._options.retry.afterStatusCodes.includes(t.response.status)) {
          let n = Number(o);
          return Number.isNaN(n) ? n = Date.parse(o) - Date.now() : n *= 1e3, this._options.retry.maxRetryAfter !== void 0 && n > this._options.retry.maxRetryAfter ? 0 : n;
        }
        if (t.response.status === 413)
          return 0;
      }
      const r = this._options.retry.delay(this._retryCount);
      return Math.min(this._options.retry.backoffLimit, r);
    }
    return 0;
  }
  _decorateResponse(t) {
    return this._options.parseJson && (t.json = async () => this._options.parseJson(await t.text())), t;
  }
  async _retry(t) {
    try {
      return await t();
    } catch (r) {
      const o = Math.min(this._calculateRetryDelay(r), re);
      if (o !== 0 && this._retryCount > 0) {
        await ao(o, { signal: this._options.signal });
        for (const n of this._options.hooks.beforeRetry)
          if (await n({
            request: this.request,
            options: this._options,
            error: r,
            retryCount: this._retryCount
          }) === wt)
            return;
        return this._retry(t);
      }
      throw r;
    }
  }
  async _fetch() {
    for (const r of this._options.hooks.beforeRequest) {
      const o = await r(this.request, this._options);
      if (o instanceof Request) {
        this.request = o;
        break;
      }
      if (o instanceof Response)
        return o;
    }
    const t = co(this.request, this._options);
    return this._options.timeout === !1 ? this._options.fetch(this.request.clone(), t) : io(this.request.clone(), t, this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(t, r) {
    const o = Number(t.headers.get("content-length")) || 0;
    let n = 0;
    return t.status === 204 ? (r && r({ percent: 1, totalBytes: o, transferredBytes: n }, new Uint8Array()), new globalThis.Response(null, {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(s) {
        const i = t.body.getReader();
        r && r({ percent: 0, transferredBytes: 0, totalBytes: o }, new Uint8Array());
        async function a() {
          const { done: c, value: l } = await i.read();
          if (c) {
            s.close();
            return;
          }
          if (r) {
            n += l.byteLength;
            const d = o === 0 ? 0 : n / o;
            r({ percent: d, transferredBytes: n, totalBytes: o }, l);
          }
          s.enqueue(l), await a();
        }
        await a();
      }
    }), {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const ce = (e) => {
  const t = (r, o) => G.create(r, L(e, o));
  for (const r of vt)
    t[r] = (o, n) => G.create(o, L(e, n, { method: r }));
  return t.create = (r) => ce(L(r)), t.extend = (r) => ce(L(e, r)), t.stop = wt, t;
}, lo = ce();
function uo(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var n = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(r, o, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), r;
}
var Fe = {}, z = {}, I = {}, $e;
function pe() {
  if ($e) return I;
  $e = 1, Object.defineProperty(I, "__esModule", { value: !0 }), I.isPlainObject = I.jsonParse = I.createIncludeNamesTree = void 0;
  function e(o, n) {
    var s = o.split("."), i = s.shift(), a = s.length, c = null;
    a && (c = n[i] || {}, e(s.join("."), c)), n[i] = c;
  }
  I.createIncludeNamesTree = e;
  function t(o) {
    var n;
    try {
      n = JSON.parse(o);
    } catch (s) {
      n = {}, console.warn(s);
    }
    return n;
  }
  I.jsonParse = t;
  var r = function(o) {
    return !!o && typeof o == "object" && o.constructor === Object;
  };
  return I.isPlainObject = r, I;
}
var T = {}, le = function(e, t) {
  return le = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
    r.__proto__ = o;
  } || function(r, o) {
    for (var n in o) Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
  }, le(e, t);
};
function Pt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  le(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var W = function() {
  return W = Object.assign || function(e) {
    for (var t, r = 1, o = arguments.length; r < o; r++) {
      t = arguments[r];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, W.apply(this, arguments);
};
function It(e, t) {
  var r = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, o = Object.getOwnPropertySymbols(e); n < o.length; n++)
      t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (r[o[n]] = e[o[n]]);
  return r;
}
function At(e, t, r, o) {
  var n = arguments.length, s = n < 3 ? t : o === null ? o = Object.getOwnPropertyDescriptor(t, r) : o, i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(e, t, r, o);
  else for (var a = e.length - 1; a >= 0; a--) (i = e[a]) && (s = (n < 3 ? i(s) : n > 3 ? i(t, r, s) : i(t, r)) || s);
  return n > 3 && s && Object.defineProperty(t, r, s), s;
}
function Dt(e, t) {
  return function(r, o) {
    t(r, o, e);
  };
}
function po(e, t, r, o, n, s) {
  function i(R) {
    if (R !== void 0 && typeof R != "function") throw new TypeError("Function expected");
    return R;
  }
  for (var a = o.kind, c = a === "getter" ? "get" : a === "setter" ? "set" : "value", l = !t && e ? o.static ? e : e.prototype : null, d = t || (l ? Object.getOwnPropertyDescriptor(l, o.name) : {}), u, f = !1, p = r.length - 1; p >= 0; p--) {
    var h = {};
    for (var y in o) h[y] = y === "access" ? {} : o[y];
    for (var y in o.access) h.access[y] = o.access[y];
    h.addInitializer = function(R) {
      if (f) throw new TypeError("Cannot add initializers after decoration has completed");
      s.push(i(R || null));
    };
    var g = (0, r[p])(a === "accessor" ? { get: d.get, set: d.set } : d[c], h);
    if (a === "accessor") {
      if (g === void 0) continue;
      if (g === null || typeof g != "object") throw new TypeError("Object expected");
      (u = i(g.get)) && (d.get = u), (u = i(g.set)) && (d.set = u), (u = i(g.init)) && n.unshift(u);
    } else (u = i(g)) && (a === "field" ? n.unshift(u) : d[c] = u);
  }
  l && Object.defineProperty(l, o.name, d), f = !0;
}
function fo(e, t, r) {
  for (var o = arguments.length > 2, n = 0; n < t.length; n++)
    r = o ? t[n].call(e, r) : t[n].call(e);
  return o ? r : void 0;
}
function ho(e) {
  return typeof e == "symbol" ? e : "".concat(e);
}
function yo(e, t, r) {
  return typeof t == "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", { configurable: !0, value: r ? "".concat(r, " ", t) : t });
}
function Ot(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
function Tt(e, t, r, o) {
  function n(s) {
    return s instanceof r ? s : new r(function(i) {
      i(s);
    });
  }
  return new (r || (r = Promise))(function(s, i) {
    function a(d) {
      try {
        l(o.next(d));
      } catch (u) {
        i(u);
      }
    }
    function c(d) {
      try {
        l(o.throw(d));
      } catch (u) {
        i(u);
      }
    }
    function l(d) {
      d.done ? s(d.value) : n(d.value).then(a, c);
    }
    l((o = o.apply(e, t || [])).next());
  });
}
function Ct(e, t) {
  var r = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o, n, s, i;
  return i = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function a(l) {
    return function(d) {
      return c([l, d]);
    };
  }
  function c(l) {
    if (o) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, l[0] && (r = 0)), r; ) try {
      if (o = 1, n && (s = l[0] & 2 ? n.return : l[0] ? n.throw || ((s = n.return) && s.call(n), 0) : n.next) && !(s = s.call(n, l[1])).done) return s;
      switch (n = 0, s && (l = [l[0] & 2, s.value]), l[0]) {
        case 0:
        case 1:
          s = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, n = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < s[1]) {
            r.label = s[1], s = l;
            break;
          }
          if (s && r.label < s[2]) {
            r.label = s[2], r.ops.push(l);
            break;
          }
          s[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = t.call(e, r);
    } catch (d) {
      l = [6, d], n = 0;
    } finally {
      o = s = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
var Q = Object.create ? function(e, t, r, o) {
  o === void 0 && (o = r);
  var n = Object.getOwnPropertyDescriptor(t, r);
  (!n || ("get" in n ? !t.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, o, n);
} : function(e, t, r, o) {
  o === void 0 && (o = r), e[o] = t[r];
};
function bt(e, t) {
  for (var r in e) r !== "default" && !Object.prototype.hasOwnProperty.call(t, r) && Q(t, e, r);
}
function X(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], o = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && o >= e.length && (e = void 0), { value: e && e[o++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function fe(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var o = r.call(e), n, s = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = o.next()).done; ) s.push(n.value);
  } catch (a) {
    i = { error: a };
  } finally {
    try {
      n && !n.done && (r = o.return) && r.call(o);
    } finally {
      if (i) throw i.error;
    }
  }
  return s;
}
function Et() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(fe(arguments[t]));
  return e;
}
function St() {
  for (var e = 0, t = 0, r = arguments.length; t < r; t++) e += arguments[t].length;
  for (var o = Array(e), n = 0, t = 0; t < r; t++)
    for (var s = arguments[t], i = 0, a = s.length; i < a; i++, n++)
      o[n] = s[i];
  return o;
}
function jt(e, t, r) {
  if (r || arguments.length === 2) for (var o = 0, n = t.length, s; o < n; o++)
    (s || !(o in t)) && (s || (s = Array.prototype.slice.call(t, 0, o)), s[o] = t[o]);
  return e.concat(s || Array.prototype.slice.call(t));
}
function b(e) {
  return this instanceof b ? (this.v = e, this) : new b(e);
}
function Mt(e, t, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var o = r.apply(e, t || []), n, s = [];
  return n = {}, a("next"), a("throw"), a("return", i), n[Symbol.asyncIterator] = function() {
    return this;
  }, n;
  function i(p) {
    return function(h) {
      return Promise.resolve(h).then(p, u);
    };
  }
  function a(p, h) {
    o[p] && (n[p] = function(y) {
      return new Promise(function(g, R) {
        s.push([p, y, g, R]) > 1 || c(p, y);
      });
    }, h && (n[p] = h(n[p])));
  }
  function c(p, h) {
    try {
      l(o[p](h));
    } catch (y) {
      f(s[0][3], y);
    }
  }
  function l(p) {
    p.value instanceof b ? Promise.resolve(p.value.v).then(d, u) : f(s[0][2], p);
  }
  function d(p) {
    c("next", p);
  }
  function u(p) {
    c("throw", p);
  }
  function f(p, h) {
    p(h), s.shift(), s.length && c(s[0][0], s[0][1]);
  }
}
function kt(e) {
  var t, r;
  return t = {}, o("next"), o("throw", function(n) {
    throw n;
  }), o("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function o(n, s) {
    t[n] = e[n] ? function(i) {
      return (r = !r) ? { value: b(e[n](i)), done: !1 } : s ? s(i) : i;
    } : s;
  }
}
function xt(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], r;
  return t ? t.call(e) : (e = typeof X == "function" ? X(e) : e[Symbol.iterator](), r = {}, o("next"), o("throw"), o("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function o(s) {
    r[s] = e[s] && function(i) {
      return new Promise(function(a, c) {
        i = e[s](i), n(a, c, i.done, i.value);
      });
    };
  }
  function n(s, i, a, c) {
    Promise.resolve(c).then(function(l) {
      s({ value: l, done: a });
    }, i);
  }
}
function Ut(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
var mo = Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
};
function Lt(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var r in e) r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && Q(t, e, r);
  return mo(t, e), t;
}
function zt(e) {
  return e && e.__esModule ? e : { default: e };
}
function qt(e, t, r, o) {
  if (r === "a" && !o) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? o : r === "a" ? o.call(e) : o ? o.value : t.get(e);
}
function Nt(e, t, r, o, n) {
  if (o === "m") throw new TypeError("Private method is not writable");
  if (o === "a" && !n) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return o === "a" ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}
function Bt(e, t) {
  if (t === null || typeof t != "object" && typeof t != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof e == "function" ? t === e : e.has(t);
}
function Ft(e, t, r) {
  if (t != null) {
    if (typeof t != "object" && typeof t != "function") throw new TypeError("Object expected.");
    var o, n;
    if (r) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      o = t[Symbol.asyncDispose];
    }
    if (o === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      o = t[Symbol.dispose], r && (n = o);
    }
    if (typeof o != "function") throw new TypeError("Object not disposable.");
    n && (o = function() {
      try {
        n.call(this);
      } catch (s) {
        return Promise.reject(s);
      }
    }), e.stack.push({ value: t, dispose: o, async: r });
  } else r && e.stack.push({ async: !0 });
  return t;
}
var go = typeof SuppressedError == "function" ? SuppressedError : function(e, t, r) {
  var o = new Error(r);
  return o.name = "SuppressedError", o.error = e, o.suppressed = t, o;
};
function $t(e) {
  function t(o) {
    e.error = e.hasError ? new go(o, e.error, "An error was suppressed during disposal.") : o, e.hasError = !0;
  }
  function r() {
    for (; e.stack.length; ) {
      var o = e.stack.pop();
      try {
        var n = o.dispose && o.dispose.call(o.value);
        if (o.async) return Promise.resolve(n).then(r, function(s) {
          return t(s), r();
        });
      } catch (s) {
        t(s);
      }
    }
    if (e.hasError) throw e.error;
  }
  return r();
}
const _o = {
  __extends: Pt,
  __assign: W,
  __rest: It,
  __decorate: At,
  __param: Dt,
  __metadata: Ot,
  __awaiter: Tt,
  __generator: Ct,
  __createBinding: Q,
  __exportStar: bt,
  __values: X,
  __read: fe,
  __spread: Et,
  __spreadArrays: St,
  __spreadArray: jt,
  __await: b,
  __asyncGenerator: Mt,
  __asyncDelegator: kt,
  __asyncValues: xt,
  __makeTemplateObject: Ut,
  __importStar: Lt,
  __importDefault: zt,
  __classPrivateFieldGet: qt,
  __classPrivateFieldSet: Nt,
  __classPrivateFieldIn: Bt,
  __addDisposableResource: Ft,
  __disposeResources: $t
}, vo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: Ft,
  get __assign() {
    return W;
  },
  __asyncDelegator: kt,
  __asyncGenerator: Mt,
  __asyncValues: xt,
  __await: b,
  __awaiter: Tt,
  __classPrivateFieldGet: qt,
  __classPrivateFieldIn: Bt,
  __classPrivateFieldSet: Nt,
  __createBinding: Q,
  __decorate: At,
  __disposeResources: $t,
  __esDecorate: po,
  __exportStar: bt,
  __extends: Pt,
  __generator: Ct,
  __importDefault: zt,
  __importStar: Lt,
  __makeTemplateObject: Ut,
  __metadata: Ot,
  __param: Dt,
  __propKey: ho,
  __read: fe,
  __rest: It,
  __runInitializers: fo,
  __setFunctionName: yo,
  __spread: Et,
  __spreadArray: jt,
  __spreadArrays: St,
  __values: X,
  default: _o
}, Symbol.toStringTag, { value: "Module" })), he = /* @__PURE__ */ uo(vo);
var Je;
function Jt() {
  if (Je) return T;
  Je = 1, Object.defineProperty(T, "__esModule", { value: !0 }), T.ModelsSerializer = void 0;
  var e = he, t = pe(), r = function() {
    function o(n) {
      n && this.setPropertiesMapper(n), this.buildIncludedIndex = 0;
    }
    return o.prototype.setPropertiesMapper = function(n) {
      this.propertiesMapper = n;
    }, o.prototype.setStuff = function(n) {
      this.stuff = n;
    }, o.prototype.setIncludeNames = function(n) {
      if (Array.isArray(n)) {
        var s = {};
        n.forEach(function(i) {
          (0, t.createIncludeNamesTree)(i, s);
        }), this.includeNamesTree = s;
      } else
        this.includeNamesTree = n;
    }, o.prototype.build = function() {
      var n = this, s = n.stuff, i = n.propertiesMapper;
      if (!i || typeof i != "object")
        throw new Error("ModelsSerializer cannot build, propertiesMapper is not set");
      if (!s || typeof s != "object")
        throw new Error("ModelsSerializer cannot build, stuff is not set");
      var a = {}, c = {};
      if (s && Array.isArray(s)) {
        for (var l = s.length, d = [], u = 0; u < l; u++)
          d.push(this.buildDataByModel(s[u])), this.buildIncludedByModel(s[u], this.includeNamesTree, c);
        a.data = d;
      } else s ? (a.data = this.buildDataByModel(s), this.buildIncludedByModel(s, this.includeNamesTree, c)) : s === null && (a.data = null);
      return Object.keys(c).length && (a.included = Object.values(c)), a;
    }, o.prototype.buildDataByModel = function(n) {
      var s = this.propertiesMapper.getId(n), i = this.propertiesMapper.getType(n), a = this.propertiesMapper.getAttributes(n), c = e.__assign(e.__assign({ type: i }, typeof s < "u" ? { id: s } : {}), typeof a < "u" ? { attributes: a } : {});
      if (typeof c.type != "string" || !c.type)
        throw console.warn("ModelsSerializer cannot buildDataByModel, type is not set or incorrect", n), new Error("ModelsSerializer cannot buildDataByModel, type is not set or incorrect");
      var l = this.buildRelationshipsByModel(n);
      return l && Object.keys(l).length && (c.relationships = l), c;
    }, o.prototype.buildResourceObjectPart = function(n) {
      var s = this.propertiesMapper.getId(n), i = this.propertiesMapper.getType(n);
      return e.__assign({ type: i }, typeof s > "u" ? {} : { id: s });
    }, o.prototype.buildRelationshipsByModel = function(n) {
      var s = this, i = this.propertiesMapper.getRelationships(n);
      if (!(!i || !Object.keys(i).length)) {
        var a = {};
        return Object.keys(i).forEach(function(c) {
          var l = i[c];
          if (Array.isArray(l)) {
            for (var d = [], u = 0, f = l; u < f.length; u++) {
              var p = f[u], h = s.buildResourceObjectPart(p);
              "type" in h ? d.push(h) : console.error("Can't create data item for relationship ".concat(c, `,
                            it doesn't have 'id' or 'type', it was skipped`), p);
            }
            a[c] = {
              data: d
            };
          } else if (l) {
            var y = s.buildResourceObjectPart(l);
            "type" in y ? a[c] = {
              data: y
            } : console.error("Can't create data for relationship ".concat(c, ", it doesn't have 'type', it was skipped"), l);
          } else
            a[c] = {
              data: l
            };
        }), a;
      }
    }, o.prototype.buildIncludedByModel = function(n, s, i) {
      if (i === void 0 && (i = {}), !(!s || !Object.keys(s).length)) {
        var a = this.propertiesMapper.getRelationships(n);
        if (!(!a || !Object.keys(a).length))
          for (var c = Object.keys(s), l = c.length, d = 0; d < l; d++) {
            var u = c[d], f = a[u];
            if (f)
              if (Array.isArray(f))
                for (var p = f.length, h = 0; h < p; h++) {
                  var y = f[h];
                  this.buildIncludedItem(y, s[u], i);
                }
              else
                this.buildIncludedItem(f, s[u], i);
          }
      }
    }, o.prototype.buildIncludedItem = function(n, s, i) {
      var a = this.propertiesMapper.getId(n), c = this.propertiesMapper.getType(n), l = c + a;
      (!a || !i[l]) && (l in i && (l += this.buildIncludedIndex, this.buildIncludedIndex += 1), i[l] = this.buildDataByModel(n), s && this.buildIncludedByModel(n, s, i));
    }, o;
  }();
  return T.ModelsSerializer = r, T.default = r, T;
}
var C = {}, He;
function Ht() {
  if (He) return C;
  He = 1, Object.defineProperty(C, "__esModule", { value: !0 }), C.JsonDeserializer = void 0;
  var e = function() {
    function t(r, o, n) {
      this.preferNestedDataFromData = !1, this.setPropertiesMapper(r), this.setDeserializeCache(o), n && n.preferNestedDataFromData && (this.preferNestedDataFromData = !0);
    }
    return t.prototype.setDeserializeCache = function(r) {
      this.dc = r;
    }, t.prototype.setPropertiesMapper = function(r) {
      this.pm = r;
    }, t.prototype.setJsonParsedObject = function(r) {
      this.body = r;
    }, t.prototype.build = function() {
      var r = this.body.data, o;
      if (Array.isArray(r)) {
        o = [];
        for (var n = r.length, s = 0; s < n; s++)
          if (r[s]) {
            var i = this.buildModelByData(r[s]);
            i && o.push(i);
          }
      } else r && (o = this.buildModelByData(r));
      return o;
    }, t.prototype.buildModelByData = function(r, o) {
      var n = this.dc.getCachedModel(r, o);
      if (n)
        return n;
      var s = this.pm.createModel(r.type);
      if (this.dc.handleModel(s, r, o), s) {
        this.pm.setId(s, r.id), r.attributes && this.pm.setAttributes(s, r.attributes), r.meta && this.pm.setMeta && this.pm.setMeta(s, r.meta), r.links && this.pm.setLinks && this.pm.setLinks(s, r.links), o != null && o.meta && this.pm.setResourceIdObjMeta(s, o.meta);
        var i = this.buildRelationsByData(r, s);
        i && this.pm.setRelationships(s, i);
      }
      return s;
    }, t.prototype.buildRelationsByData = function(r, o) {
      var n = {};
      if (r.relationships)
        for (var s in r.relationships) {
          var i = r.relationships[s];
          if (Array.isArray(i.data)) {
            n[s] = [];
            for (var a = i.data.length, c = void 0, l = 0; l < a; l++)
              if (c = i.data[l], !!c) {
                var d = this.buildDataFromIncludedOrData(c.id, c.type);
                n[s].push(this.buildModelByData(d, c));
              }
          } else if (i.data) {
            var d = this.buildDataFromIncludedOrData(i.data.id, i.data.type);
            n[s] = this.buildModelByData(d, i.data);
          } else i.data === null && (n[s] = null);
          if (i.links) {
            var u = this.pm.setRelationshipLinks;
            u && u(o, s, i.links);
          }
          if (i.meta) {
            var f = this.pm.setRelationshipMeta;
            f && f(o, s, i.meta);
          }
        }
      return Object.keys(n).length ? n : null;
    }, t.prototype.buildDataFromIncludedOrData = function(r, o) {
      if (this.preferNestedDataFromData) {
        var n = this.buildDataInObject(), s = n[o + r];
        if (s)
          return s;
      }
      var i = this.buildIncludedInObject(), a = i[o + r];
      if (a)
        return a;
      if (!this.preferNestedDataFromData) {
        var n = this.buildDataInObject(), s = n[o + r];
        if (s)
          return s;
      }
      return { id: r, type: o };
    }, t.prototype.buildDataInObject = function() {
      if (!this.dataInObject) {
        this.dataInObject = {};
        var r = this.body.data, o = r.length;
        if (r && o)
          for (var n = 0; n < o; n++) {
            var s = r[n];
            this.dataInObject[s.type + s.id] = s;
          }
        else r && (this.dataInObject[r.type + r.id] = r);
      }
      return this.dataInObject;
    }, t.prototype.buildIncludedInObject = function() {
      if (!this.includedInObject && (this.includedInObject = {}, this.body.included))
        for (var r = this.body.included.length, o = 0; o < r; o++) {
          var n = this.body.included[o];
          this.includedInObject[n.type + n.id] = n;
        }
      return this.includedInObject;
    }, t;
  }();
  return C.JsonDeserializer = e, C.default = e, C;
}
var q = {}, Ve;
function wo() {
  if (Ve) return q;
  Ve = 1, Object.defineProperty(q, "__esModule", { value: !0 });
  var e = function() {
    function t(r) {
      this.cachedModels = {}, this.setPropertiesMapper(r);
    }
    return t.prototype.setPropertiesMapper = function(r) {
      this.propertiesMapper = r;
    }, t.prototype.setReduxObject = function(r) {
      this.reduxObject = r;
    }, t.prototype.setEntityType = function(r) {
      this.entityType = r;
    }, t.prototype.setEntityIds = function(r) {
      this.ids = r;
    }, t.prototype.setReturnBuilderInRelations = function(r) {
      this.returnBuilderInRelations = r;
    }, t.prototype.build = function() {
      var r = this, o = this, n = o.reduxObject, s = o.entityType, i = o.propertiesMapper;
      if (!i || typeof i != "object")
        throw new Error("ReduxObjectDenormalizer cannot build, propertiesMapper is not set");
      if (!n || typeof n != "object")
        throw new Error("ReduxObjectDenormalizer cannot build, reduxObject is not set");
      if (!s)
        throw new Error("ReduxObjectDenormalizer cannot build, entityType is not set");
      if (!n[s])
        return null;
      var a = this.ids;
      if (a || (a = Object.keys(n[s])), Array.isArray(a)) {
        if (!a.length)
          return null;
        var c = [];
        return a.forEach(function(l) {
          var d = r.buildModel(s, l);
          d && c.push(d);
        }), c;
      }
      return this.buildModel(s, a);
    }, t.prototype.buildModel = function(r, o) {
      var n = this.reduxObject;
      if (!n[r])
        return null;
      var s = n[r][o];
      if (!s)
        return null;
      var i = "".concat(r, "-").concat(o), a = this.cachedModels[i];
      if (!a && (a = this.propertiesMapper.createModel(r), a)) {
        this.cachedModels[i] = a, this.propertiesMapper.setId(a, s.id), s.attributes && this.propertiesMapper.setAttributes(a, s.attributes);
        var c = this.buildRelationships(a, s.relationships);
        c && this.propertiesMapper.setRelationships(a, c);
      }
      return a;
    }, t.prototype.buildRelationships = function(r, o) {
      var n = this;
      if (!o)
        return null;
      var s = Object.keys(o);
      if (!s.length)
        return null;
      var i = {};
      return s.forEach(function(a) {
        var c = o[a];
        if (c && c.data && (n.returnBuilderInRelations ? i[a] = n.buildRelationModels.bind(n, c.data) : i[a] = n.buildRelationModels(c.data)), c && c.links && n.propertiesMapper.setRelationshipLinks(r, a, c.links), c && c.meta) {
          var l = n.propertiesMapper.setRelationshipMeta;
          l && l(r, a, c.meta);
        }
      }), Object.keys(i).length ? i : null;
    }, t.prototype.buildRelationModels = function(r) {
      var o = this;
      if (Array.isArray(r)) {
        var n = [];
        return r.forEach(function(s) {
          var i = o.buildModel(s.type, s.id);
          n.push(i || s);
        }), n;
      } else if (r.id && r.type)
        return this.buildModel(r.type, r.id) || r;
      return null;
    }, t;
  }();
  return q.default = e, q;
}
var Ge = {}, We;
function ye() {
  return We || (We = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.JsonPropertiesMapper = e.defineRelationGetter = e.ModelPropertiesMapper = e.RELATIONSHIP_NAMES_PROP = void 0;
    var t = he;
    e.RELATIONSHIP_NAMES_PROP = "relationshipNames";
    var r = function() {
      function s() {
      }
      return s.prototype.getId = function(i) {
        return i.id;
      }, s.prototype.getType = function(i) {
        return i.type;
      }, s.prototype.getAttributes = function(i) {
        var a = ["id", "type", e.RELATIONSHIP_NAMES_PROP];
        Array.isArray(i[e.RELATIONSHIP_NAMES_PROP]) ? a.push.apply(a, i[e.RELATIONSHIP_NAMES_PROP]) : i[e.RELATIONSHIP_NAMES_PROP] && console.warn("Can't getAttributes correctly, '".concat(e.RELATIONSHIP_NAMES_PROP, "' property of ").concat(i.type, "-").concat(i.id, ` model
                isn't array of relationship names`), i[e.RELATIONSHIP_NAMES_PROP]);
        var c = {};
        return Object.keys(i).forEach(function(l) {
          a.indexOf(l) === -1 && (c[l] = i[l]);
        }), c;
      }, s.prototype.getRelationships = function(i) {
        var a = i[e.RELATIONSHIP_NAMES_PROP];
        if (!(!a || Array.isArray(a) && !a.length)) {
          if (a && !Array.isArray(a)) {
            console.warn(`Can't getRelationships correctly,
                '`.concat(e.RELATIONSHIP_NAMES_PROP, "' property of ").concat(i.type, "-").concat(i.id, ` model
                isn't array of relationship names`), i[e.RELATIONSHIP_NAMES_PROP]);
            return;
          }
          var c = {};
          return a.forEach(function(l) {
            i[l] !== void 0 && (c[l] = i[l]);
          }), c;
        }
      }, s;
    }();
    e.ModelPropertiesMapper = r;
    function o(s, i, a) {
      Object.defineProperty(s, i, {
        enumerable: !0,
        configurable: !0,
        set: function(c) {
          delete s[i], s[i] = c;
        },
        get: function() {
          return delete s[i], s[i] = a();
        }
      });
    }
    e.defineRelationGetter = o;
    var n = function() {
      function s() {
      }
      return s.prototype.createModel = function(i) {
        return { type: i };
      }, s.prototype.setId = function(i, a) {
        i.id = a;
      }, s.prototype.setAttributes = function(i, a) {
        Object.keys(a).forEach(function(c) {
          i[c] = a[c];
        });
      }, s.prototype.setMeta = function(i, a) {
        i.meta = a;
      }, s.prototype.setLinks = function(i, a) {
        i.links = a;
      }, s.prototype.setResourceIdObjMeta = function(i, a) {
        i.resourceIdObjMeta = a;
      }, s.prototype.setRelationships = function(i, a) {
        Object.keys(a).forEach(function(d) {
          typeof a[d] == "function" ? o(i, d, a[d]) : i[d] = a[d];
        });
        var c = Object.keys(a), l = i[e.RELATIONSHIP_NAMES_PROP];
        l && l.length ? i[e.RELATIONSHIP_NAMES_PROP] = t.__spreadArray(t.__spreadArray([], l, !0), c, !0).filter(function(d, u, f) {
          return f.indexOf(d) === u;
        }) : i[e.RELATIONSHIP_NAMES_PROP] = c;
      }, s.prototype.setRelationshipLinks = function(i, a, c) {
      }, s.prototype.setRelationshipMeta = function(i, a, c) {
      }, s;
    }();
    e.JsonPropertiesMapper = n;
  }(Ge)), Ge;
}
var A = {}, Xe;
function Ro() {
  if (Xe) return A;
  Xe = 1, Object.defineProperty(A, "__esModule", { value: !0 }), A.DeserializeCache = A.jsonStringify = void 0;
  function e(r) {
    var o;
    try {
      o = JSON.stringify(r);
    } catch (n) {
      o = "", console.warn(n);
    }
    return o;
  }
  A.jsonStringify = e;
  var t = function() {
    function r() {
      this.cachedModels = {};
    }
    return r.prototype.getCachedModel = function(o, n) {
      var s = this.createCacheKey(o, n);
      return this.cachedModels[s] || null;
    }, r.prototype.handleModel = function(o, n, s) {
      var i = this.createCacheKey(n, s), a = n.attributes || n.relationships;
      i && a && (this.cachedModels[i] = o);
    }, r.prototype.createCacheKey = function(o, n) {
      if (!(!o.id || !o.type)) {
        var s = n ? "".concat(n.type, "-").concat(n.id) : "";
        return n != null && n.meta && (s += "-".concat(e(n.meta))), o.meta ? "".concat(o.type, "-").concat(o.id, "-").concat(e(o.meta), "-").concat(s) : "".concat(o.type, "-").concat(o.id, "-").concat(s);
      }
    }, r;
  }();
  return A.DeserializeCache = t, A;
}
var Ke;
function Po() {
  if (Ke) return z;
  Ke = 1, Object.defineProperty(z, "__esModule", { value: !0 });
  var e = pe(), t = Jt(), r = Ht(), o = wo(), n = ye(), s = Ro(), i = function() {
    function a(c) {
      this.modelPropertiesMapper = new n.ModelPropertiesMapper(), this.jsonPropertiesMapper = new n.JsonPropertiesMapper(), this.DeserializeCache = s.DeserializeCache, this.ModelsSerializer = t.default, this.JsonDeserializer = r.default, c && c.modelPropertiesMapper && (this.modelPropertiesMapper = c.modelPropertiesMapper), c && c.jsonPropertiesMapper && (this.jsonPropertiesMapper = c.jsonPropertiesMapper), c && c.DeserializeCache && (this.DeserializeCache = c.DeserializeCache), c && c.ModelsSerializer && (this.ModelsSerializer = c.ModelsSerializer), c && c.JsonDeserializer && (this.JsonDeserializer = c.JsonDeserializer);
    }
    return a.prototype.serialize = function(c) {
      var l = c.stuff, d = c.includeNames;
      if (!l)
        throw new Error("Jsona can not serialize, stuff is not passed");
      var u = new this.ModelsSerializer(this.modelPropertiesMapper);
      return u.setStuff(l), d && u.setIncludeNames(d), u.build();
    }, a.prototype.deserialize = function(c, l) {
      if (!c)
        throw new Error("Jsona can not deserialize, body is not passed");
      var d = new this.DeserializeCache(), u = new this.JsonDeserializer(this.jsonPropertiesMapper, d, l);
      return typeof c == "string" ? u.setJsonParsedObject((0, e.jsonParse)(c)) : u.setJsonParsedObject(c), u.build();
    }, a.prototype.denormalizeReduxObject = function(c) {
      var l = c.reduxObject, d = c.entityType, u = c.entityIds, f = c.returnBuilderInRelations, p = f === void 0 ? !1 : f;
      if (!l)
        throw new Error("Jsona can not denormalize ReduxObject, incorrect reduxObject passed");
      if (!d)
        throw new Error("Jsona can not denormalize ReduxObject, entityType is not passed");
      if (!l[d])
        return null;
      var h = new o.default(this.jsonPropertiesMapper);
      return h.setReduxObject(l), h.setEntityType(d), h.setReturnBuilderInRelations(p), u && h.setEntityIds(Array.isArray(u) ? u : u.toString()), h.build();
    }, a;
  }();
  return z.default = i, z;
}
var D = {}, Ye;
function Io() {
  if (Ye) return D;
  Ye = 1, Object.defineProperty(D, "__esModule", { value: !0 }), D.SwitchCaseJsonMapper = D.SwitchCaseModelMapper = void 0;
  var e = he, t = ye(), r = pe(), o = function(s) {
    e.__extends(i, s);
    function i(a) {
      var c = s.call(this) || this, l = a || {}, d = l.switchAttributes, u = d === void 0 ? !0 : d, f = l.switchRelationships, p = f === void 0 ? !0 : f, h = l.switchType, y = h === void 0 ? !0 : h, g = l.switchChar, R = g === void 0 ? "-" : g;
      return c.switchAttributes = u, c.switchRelationships = p, c.switchType = y, c.switchChar = R, c.regex = new RegExp(/([a-z][A-Z0-9])/g), c;
    }
    return i.prototype.getType = function(a) {
      var c = s.prototype.getType.call(this, a);
      return !this.switchType || !c ? c : this.convertFromCamelCaseString(c);
    }, i.prototype.getAttributes = function(a) {
      var c = s.prototype.getAttributes.call(this, a);
      return !this.switchAttributes || !c ? c : this.convertFromCamelCase(c);
    }, i.prototype.getRelationships = function(a) {
      var c = s.prototype.getRelationships.call(this, a);
      return !this.switchRelationships || !c ? c : this.convertFromCamelCase(c);
    }, i.prototype.convertFromCamelCase = function(a) {
      var c = this;
      if (Array.isArray(a))
        return a.map(function(d) {
          return c.convertFromCamelCase(d);
        });
      if ((0, r.isPlainObject)(a)) {
        var l = {};
        return Object.entries(a).forEach(function(d) {
          var u = d[0], f = d[1], p = c.convertFromCamelCaseString(u);
          l[p] = c.convertFromCamelCase(f);
        }), l;
      }
      return a;
    }, i.prototype.convertFromCamelCaseString = function(a) {
      var c = this;
      return a.replace(this.regex, function(l) {
        return l[0] + c.switchChar + l[1].toLowerCase();
      });
    }, i;
  }(t.ModelPropertiesMapper);
  D.SwitchCaseModelMapper = o;
  var n = function(s) {
    e.__extends(i, s);
    function i(a) {
      var c = s.call(this) || this, l = a || {}, d = l.camelizeAttributes, u = d === void 0 ? !0 : d, f = l.camelizeRelationships, p = f === void 0 ? !0 : f, h = l.camelizeType, y = h === void 0 ? !0 : h, g = l.camelizeMeta, R = g === void 0 ? !1 : g, Ue = l.switchChar, Zt = Ue === void 0 ? "-" : Ue;
      return c.camelizeAttributes = u, c.camelizeRelationships = p, c.camelizeType = y, c.camelizeMeta = R, c.switchChar = Zt, c.regex = new RegExp("".concat(c.switchChar, "([a-z0-9])"), "g"), c;
    }
    return i.prototype.createModel = function(a) {
      if (!this.camelizeType)
        return { type: a };
      var c = this.convertToCamelCaseString(a);
      return { type: c };
    }, i.prototype.setAttributes = function(a, c) {
      if (!this.camelizeAttributes)
        return s.prototype.setAttributes.call(this, a, c);
      Object.assign(a, this.convertToCamelCase(c));
    }, i.prototype.setMeta = function(a, c) {
      if (!this.camelizeMeta)
        return s.prototype.setMeta.call(this, a, c);
      a.meta = this.convertToCamelCase(c);
    }, i.prototype.setRelationships = function(a, c) {
      var l = this;
      s.prototype.setRelationships.call(this, a, c), this.camelizeRelationships && a[t.RELATIONSHIP_NAMES_PROP].forEach(function(d, u) {
        var f = l.convertToCamelCaseString(d);
        f !== d && (a[f] = a[d], delete a[d], a[t.RELATIONSHIP_NAMES_PROP][u] = f);
      });
    }, i.prototype.convertToCamelCase = function(a) {
      var c = this;
      if (Array.isArray(a))
        return a.map(function(d) {
          return c.convertToCamelCase(d);
        });
      if ((0, r.isPlainObject)(a)) {
        var l = {};
        return Object.entries(a).forEach(function(d) {
          var u = d[0], f = d[1], p = c.convertToCamelCaseString(u);
          l[p] = c.convertToCamelCase(f);
        }), l;
      }
      return a;
    }, i.prototype.convertToCamelCaseString = function(a) {
      return a.replace(this.regex, function(c) {
        return c[1].toUpperCase();
      });
    }, i;
  }(t.JsonPropertiesMapper);
  return D.SwitchCaseJsonMapper = n, D;
}
var Ze;
function Ao() {
  return Ze || (Ze = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SwitchCaseJsonMapper = e.SwitchCaseModelMapper = e.JsonPropertiesMapper = e.ModelPropertiesMapper = e.JsonDeserializer = e.ModelsSerializer = e.Jsona = void 0;
    var t = Po();
    e.Jsona = t.default;
    var r = Jt();
    e.ModelsSerializer = r.default;
    var o = Ht();
    e.JsonDeserializer = o.default;
    var n = ye();
    Object.defineProperty(e, "ModelPropertiesMapper", { enumerable: !0, get: function() {
      return n.ModelPropertiesMapper;
    } }), Object.defineProperty(e, "JsonPropertiesMapper", { enumerable: !0, get: function() {
      return n.JsonPropertiesMapper;
    } });
    var s = Io();
    Object.defineProperty(e, "SwitchCaseModelMapper", { enumerable: !0, get: function() {
      return s.SwitchCaseModelMapper;
    } }), Object.defineProperty(e, "SwitchCaseJsonMapper", { enumerable: !0, get: function() {
      return s.SwitchCaseJsonMapper;
    } }), e.default = t.default;
  }(Fe)), Fe;
}
var Qe = Ao();
const Do = new Qe.Jsona({
  jsonPropertiesMapper: new Qe.SwitchCaseJsonMapper()
}), me = (...e) => Do.deserialize(...e), Oo = async (e, t, r) => {
  if (r.ok) {
    const o = await r.text();
    if (!o)
      return new Response(null, r);
    const n = me(o);
    return n ? new Response(JSON.stringify(n), r) : new Response(o, r);
  }
  return r;
}, To = (e, t) => {
  var r, o;
  Z() || (o = (r = window.DD_RUM) == null ? void 0 : r.addError) == null || o.call(r, e, t);
}, Co = (e, t) => {
  console.error(e, t);
}, bo = (e, t) => {
  To(e, t), ut() && wr(window.location.host) && Co(e, t);
}, Eo = async (e) => (bo(e, {
  request: {
    url: e.request.url
  },
  response: {
    status: e.response.status,
    body: await So(e.response)
  }
}), e), So = async (e) => {
  try {
    return await e.clone().json();
  } catch {
    return await e.clone().text();
  }
}, jo = (e) => {
  const { origin: t } = globalThis.location;
  return {
    ...e,
    prefixUrl: `${t}${Or()}`
  };
}, Mo = "Authorization", ko = "Bearer", xo = (e) => {
  const t = Gr();
  if (t && Wr(t)) {
    Vr();
    return;
  }
  t && e.headers.set(Mo, `${ko} ${t}`);
}, Uo = "X-Fondof-Beta", Lo = (e) => {
  gr(new URL(e.url).host) && e.headers.set(Uo, "true");
}, zo = "X-Fondof-Is-Canary", qo = (e) => {
  _r() && e.headers.set(zo, "true");
}, No = "X-Fondof-Internal", Bo = (e) => {
  vr() && e.headers.set(No, "true");
}, Fo = "Accept-Language", $o = {
  de: "de_DE,de;q=0.8",
  en: "en_US,en;q=0.8",
  fr: "fr_FR,fr;q=0.8",
  es: "es_ES,es;q=0.8",
  da: "da_DK,dk;q=0.8",
  it: "it_IT,it;q=0.8"
}, Jo = () => $o[Tr()], Ho = (e) => e.headers.set(Fo, Jo());
let N;
const Vo = new Uint8Array(16);
function Go() {
  if (!N && (N = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !N))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return N(Vo);
}
const _ = [];
for (let e = 0; e < 256; ++e)
  _.push((e + 256).toString(16).slice(1));
function Wo(e, t = 0) {
  return _[e[t + 0]] + _[e[t + 1]] + _[e[t + 2]] + _[e[t + 3]] + "-" + _[e[t + 4]] + _[e[t + 5]] + "-" + _[e[t + 6]] + _[e[t + 7]] + "-" + _[e[t + 8]] + _[e[t + 9]] + "-" + _[e[t + 10]] + _[e[t + 11]] + _[e[t + 12]] + _[e[t + 13]] + _[e[t + 14]] + _[e[t + 15]];
}
const Xo = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), et = {
  randomUUID: Xo
};
function Ko(e, t, r) {
  if (et.randomUUID && !e)
    return et.randomUUID();
  e = e || {};
  const o = e.random || (e.rng || Go)();
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, Wo(o);
}
const tt = "X-Anonymous-Customer-Unique-Id", rt = "uuid", ot = yt.create("localStorage"), Yo = (e) => {
  let t = e.headers.get(tt) || ot.get(rt);
  t || (t = Ko(), ot.set(rt, t)), e.headers.set(tt, t);
}, ge = (e, t) => {
  const r = [];
  for (const [o, n] of Object.entries(e))
    t[o] && r.push(n);
  return r;
}, Zo = (e) => (t, r) => {
  const o = ge(e, r);
  for (const n of o) {
    const s = n(t, r);
    if (s instanceof Response)
      return s;
  }
}, Qo = (e) => async (t, r, o) => {
  const n = ge(e, r);
  for (const s of n) {
    const i = await s(t, r, o);
    i instanceof Response && (o = i);
  }
  return o;
}, en = (e, t) => {
  const r = ge(e, t);
  for (const o of r)
    t = o(t);
  return t;
}, tn = lo.extend({
  timeout: !1,
  retry: 0,
  headers: {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json;version=1.1"
  },
  fondOfInternal: !0,
  auth: !0,
  language: !0,
  uuid: !1,
  deserialize: !1,
  beta: !0,
  canary: !0
}), ee = {
  new: (e = {}) => {
    var t, r, o;
    return e.hooks = {
      ...e.hooks || {},
      beforeRequest: [
        Zo({
          fondOfInternal: Bo,
          auth: xo,
          language: Ho,
          uuid: Yo,
          beta: Lo,
          canary: qo
        }),
        ...((t = e.hooks) == null ? void 0 : t.beforeRequest) || []
      ],
      afterResponse: [
        Qo({
          deserialize: Oo
        }),
        ...((r = e.hooks) == null ? void 0 : r.afterResponse) || []
      ],
      beforeError: [...((o = e.hooks) == null ? void 0 : o.beforeError) || [], Eo]
    }, en(
      {
        shopPrefixUrl: jo
      },
      e
    ), tn.extend(e);
  }
}, rn = () => {
  const e = import.meta.env.PUBLIC_GLUE_API_URL;
  if (!e)
    throw "You need to provide the glue api url";
  return e;
}, m = ee.new({
  prefixUrl: rn()
}), on = () => {
  const e = import.meta.env.PUBLIC_SERVICE_API_URL;
  if (!e)
    throw "You need to provide the service api url";
  return e;
}, K = ee.new({
  prefixUrl: on()
}), nn = () => {
  const e = import.meta.env.PUBLIC_BRAND_V1_API_URL;
  if (!e)
    throw "You need to provide the brand v1 api url";
  return e;
}, Vt = ee.new({
  prefixUrl: nn()
}), sn = () => {
  const e = import.meta.env.PUBLIC_BRAND_V2_API_URL;
  if (!e)
    throw "You need to provide the brand v2 api url";
  return e;
}, an = () => {
  const e = import.meta.env.PUBLIC_BRAND;
  if (!e)
    throw "You need to provide the brand";
  return e;
}, cn = ee.new({
  prefixUrl: sn(),
  headers: {
    Brand: an()
  }
}), ln = yr.create({}), dn = (e) => {
  if (e)
    return new URLSearchParams(e);
}, _e = (...e) => e.reduce(
  (t, r) => {
    const o = dn(r);
    return o != null && o.toString() && t.toString() ? new URLSearchParams(
      `${o.toString()}&${t.toString()}`
    ) : o != null && o.toString() ? o : t;
  },
  new URLSearchParams()
), E = (e, ...t) => {
  const r = _e(...t), o = r == null ? void 0 : r.get("include");
  return r == null || r.set(
    "include",
    [e, o].filter((n) => !!n).join(",")
  ), r;
}, un = (e) => {
  const t = {};
  for (const o of e.keys())
    t[o] = e.getAll(o);
  const r = {};
  for (const [o, n] of Object.entries(t)) {
    if (!(n.length > 1)) {
      r[o] = n.join();
      continue;
    }
    for (const [s, i] of Object.entries(n))
      r[`${o}[${s}]`] = i;
  }
  return r;
}, pn = async (e, t = {}) => (await m.get(`customers/${e}/addresses`, {
  ...t,
  deserialize: !0
}).json()).map(j), is = async (e, { id: t, ...r }, o = {}) => {
  const n = await m.patch(`customers/${e}/addresses/${t}`, {
    ...o,
    deserialize: !0,
    json: {
      data: {
        type: "addresses",
        attributes: r
      }
    }
  }).json();
  return j(n);
}, Y = (e) => ({
  type: "categoryNodes",
  children: e.children.map(Y),
  isActive: e.isActive,
  name: e.name,
  nodeId: e.nodeId,
  parents: e.parents.map(Y),
  url: e.url,
  id: e.id ?? void 0,
  metaDescription: e.metaDescription ?? void 0,
  metaKeywords: e.metaKeywords ?? void 0,
  metaTitle: e.metaTitle ?? void 0,
  order: e.order ?? void 0,
  links: e.links ?? void 0,
  // contentful
  bodyClass: e.bodyClass ?? void 0,
  pageType: e.pageType ?? void 0,
  contentType: e.contentType ?? void 0,
  contentfulHero: e.contentfulHero ?? void 0,
  contentfulFilter: e.contentfulFilter ?? void 0,
  contentfulContentCollection: e.contentfulContentCollection ?? void 0,
  contentfulCollectionBeforeListing: e.contentfulCollectionBeforeListing ?? void 0,
  contentfulCollectionBetweenListing: e.contentfulCollectionBetweenListing ?? void 0,
  contentfulCollectionAfterListing: e.contentfulCollectionAfterListing ?? void 0
}), as = async (e, t = {}) => {
  const r = await m.get(`category-nodes/${e}`, {
    ...t,
    deserialize: !0
  }).json();
  return Y(r);
};
let B;
const fn = new Uint8Array(16);
function hn() {
  if (!B && (B = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !B))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return B(fn);
}
const v = [];
for (let e = 0; e < 256; ++e)
  v.push((e + 256).toString(16).slice(1));
function yn(e, t = 0) {
  return v[e[t + 0]] + v[e[t + 1]] + v[e[t + 2]] + v[e[t + 3]] + "-" + v[e[t + 4]] + v[e[t + 5]] + "-" + v[e[t + 6]] + v[e[t + 7]] + "-" + v[e[t + 8]] + v[e[t + 9]] + "-" + v[e[t + 10]] + v[e[t + 11]] + v[e[t + 12]] + v[e[t + 13]] + v[e[t + 14]] + v[e[t + 15]];
}
const mn = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), nt = {
  randomUUID: mn
};
function gn(e, t, r) {
  if (nt.randomUUID && !e)
    return nt.randomUUID();
  e = e || {};
  const o = e.random || (e.rng || hn)();
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, yn(o);
}
function M(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function _n(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function vn(e, t) {
  const r = M(e);
  return isNaN(t) ? _n(e, NaN) : (r.setDate(r.getDate() + t), r);
}
function wn(e) {
  return (t) => {
    const o = (e ? Math[e] : Math.trunc)(t);
    return o === 0 ? 0 : o;
  };
}
function Rn(e, t) {
  return +M(e) - +M(t);
}
function Pn(e, t, r) {
  const o = Rn(e, t) / 1e3;
  return wn(r == null ? void 0 : r.roundingMethod)(o);
}
function Gt(e, t) {
  const r = M(e), o = M(t);
  return r.getTime() > o.getTime();
}
const In = (e) => ({
  displayName: e.displayName,
  sumAmount: e.sumAmount,
  voucherCode: e.voucherCode,
  description: e.description ?? void 0,
  quantity: e.quantity ?? void 0,
  unitAmount: e.unitAmount ?? void 0
}), An = (e) => ({
  description: e.description,
  quantity: e.quantity,
  unitAmount: e.unitAmount,
  displayName: e.displayName,
  sumAmount: e.sumAmount,
  voucherCode: e.voucherCode
}), cs = (e) => ({
  displayName: e.displayName,
  sumAmount: e.amount,
  voucherCode: e.code
}), Dn = (e) => {
  const t = {
    "payment.payone.e_wallet": "paypal",
    "payment.payone.creditcard": "creditcard",
    prepayment: "prepayment",
    paid: "paid",
    GiftCard: "giftcard"
  };
  return {
    amount: e.amount,
    paymentProviderName: e.paymentProvider,
    paymentMethodName: t[e.paymentMethod]
  };
}, On = (e) => {
  const t = [
    "One Size",
    "XXXS",
    "XXS",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
    "XXXL"
  ], r = (o) => {
    const n = o.toString(), s = t.indexOf(n);
    return s !== -1 ? [0, s.toString()] : /^\d+$/.test(n) ? [1, n] : /^\d+\/\d+$/.test(n) ? [1, n] : [3, n];
  };
  return e.map((o) => o.toString()).filter((o) => !/^\d+(\.\d+)? €$/.test(o)).sort((o, n) => {
    const [s, i] = r(o), [a, c] = r(n);
    return s !== a ? s - a : s === 1 || s === 2 ? parseFloat(i) - parseFloat(c) : i.localeCompare(c);
  });
}, Tn = (e) => {
  var t;
  return {
    name: e.name,
    localizedName: e.localizedName,
    values: On(e.values.flatMap(({ value: r }) => r)),
    activeValue: (t = e.activeValue) == null ? void 0 : t.toString(),
    parameterName: e.config.parameterName,
    isMultiValued: e.config.isMultiValued
  };
}, Cn = {
  affenzahn: [],
  satch: [],
  ergobag: []
}, bn = Cn[import.meta.env.PUBLIC_BRAND], En = (e, t = []) => {
  const r = [...bn, ...t];
  return e.filter((o) => !r.includes(o.name)).flatMap(Tn);
}, Sn = (e) => {
  const t = {
    activeMax: e.activeMax,
    activeMin: e.activeMin,
    parameterName: e.config.parameterName,
    isMultiValued: e.config.isMultiValued,
    name: e.name,
    localizedName: e.localizedName,
    max: e.max,
    min: e.min
  };
  return t.name === "price-DEFAULT-EUR-GROSS_MODE" ? {
    ...t,
    min: Math.floor(t.min / 100),
    max: Math.ceil(t.max / 100),
    activeMin: Math.floor(t.activeMin / 100),
    activeMax: Math.ceil(t.activeMax / 100)
  } : t;
}, oe = (e) => typeof e == "string" || typeof e == "number" || e instanceof Date ? new Date(e) : void 0, F = (e) => {
  const t = /* @__PURE__ */ new Date();
  return t.setFullYear(t.getFullYear() + 5), Gt(e, t);
}, w = (e) => ({
  large: e.externalUrlLarge,
  small: e.externalUrlSmall,
  sortOrder: e.sortOrder
}), ne = (e, t) => Object.entries(e).filter(([r]) => r.startsWith(t)).sort(([r], [o]) => {
  const n = parseInt(r.replace(t, ""), 10) || 0, s = parseInt(o.replace(t, ""), 10) || 0;
  return n - s;
}).map(([r, o]) => w(o[0])).filter((r) => r !== void 0), jn = (e) => {
  var t, r, o, n, s, i, a, c, l, d, u, f, p, h, y, g;
  return {
    imgBack: (t = e.imgBack) != null && t[0] ? w(e.imgBack[0]) : void 0,
    imgBackLeft: (r = e.imgBackLeft) != null && r[0] ? w(e.imgBackLeft[0]) : void 0,
    imgBackRight: (o = e.imgBackRight) != null && o[0] ? w(e.imgBackRight[0]) : void 0,
    imgDetail: ne(e, "imgDetail"),
    imgFront: (n = e.imgFront) != null && n[0] ? w(e.imgFront[0]) : void 0,
    imgFrontLeft: (s = e.imgFrontLeft) != null && s[0] ? w(e.imgFrontLeft[0]) : void 0,
    imgFrontRight: (i = e.imgFrontRight) != null && i[0] ? w(e.imgFrontRight[0]) : void 0,
    imgLeft: (a = e.imgLeft) != null && a[0] ? w(e.imgLeft[0]) : void 0,
    imgLeftInside: (c = e.imgLeftInside) != null && c[0] ? w(e.imgLeftInside[0]) : void 0,
    imgLeftOutside: (l = e.imgLeftOutside) != null && l[0] ? w(e.imgLeftOutside[0]) : void 0,
    imgModel: ne(e, "imgModel"),
    imgRight: (d = e.imgRight) != null && d[0] ? w(e.imgRight[0]) : void 0,
    imgRightInside: (u = e.imgRightInside) != null && u[0] ? w(e.imgRightInside[0]) : void 0,
    imgRightOutside: (f = e.imgRightOutside) != null && f[0] ? w(e.imgRightOutside[0]) : void 0,
    imgSetComposing: (p = e.imgSetComposing) != null && p[0] ? w(e.imgSetComposing[0]) : void 0,
    default: (h = e.default) != null && h[0] ? w(e.default[0]) : void 0,
    imgSole: (y = e.imgSole) != null && y[0] ? w(e.imgSole[0]) : void 0,
    imgTop: (g = e.imgTop) != null && g[0] ? w(e.imgTop[0]) : void 0,
    imgUsp: ne(e, "imgUsp")
  };
}, Mn = (e) => ({
  currentItemsPerPage: e.currentItemsPerPage,
  currentPage: e.currentPage,
  maxPage: e.maxPage,
  numFound: e.numFound,
  validItemsPerPage: e.config.validItemsPerPageOptions
}), kn = (e) => {
  var t, r;
  return {
    additionalContent: e.additional_content || void 0,
    batteryUnNumber: e.battery_un_number || void 0,
    bluesign: e.bluesign || void 0,
    brand: ((t = e.brand) == null ? void 0 : t.toLowerCase()) || void 0,
    careInstructions: e.care_instructions || void 0,
    caseableSku: e.caseable_sku || void 0,
    catwalkVideo: e.catwalk_video || void 0,
    collection: e.collection || void 0,
    color1: e.color_1 || void 0,
    color2: e.color_2 || void 0,
    color3: e.color_3 || void 0,
    colorCode: e.color_code || void 0,
    colors: e.colors || void 0,
    contentfulIdAdditional1: e.contentfulID_additional_1 || void 0,
    contentfulIdAdditional2: e.contentfulID_additional_2 || void 0,
    contentfulIdAdditional3: e.contentfulID_additional_3 || void 0,
    contentfulIdContentCollection: e.contentfulID_content_collection || void 0,
    contentfulIdMaterialWidget: e.contentfulID_material_widget || void 0,
    contentfulIdProductFeatures: e.contentfulID_product_features || void 0,
    contentfulIdProductInformationGroup: e.contentfulID_product_information_group || void 0,
    contentfulIdProductModelSizeInformation: e.contentfulID_product_model_size_information || void 0,
    contentfulIdRelatedStyles: e.contentfulID_related_styles || void 0,
    contentfulIdSpecialFeature: e.contentfulID_special_feature || void 0,
    contentfulIdVideoImage: e.contentfulID_video_image || void 0,
    contentfulIdVideoPacking: e.contentfulID_video_packing || void 0,
    countryOfProduction: e.country_of_production || void 0,
    deliveryTime: e.delivery_time || void 0,
    deliveryTimeForBankpayment: e.delivery_time_for_bankpayment || void 0,
    depth: e.depth || void 0,
    ean: e.ean || void 0,
    edition: ((r = e.edition) == null ? void 0 : r[0]) || void 0,
    editions: e.edition || [],
    fabric: e.fabric || void 0,
    featureDescription: e.feature_description || void 0,
    features: e.features || void 0,
    featuresHighlight: e.features_highlight || void 0,
    gender: e.gender || void 0,
    height: e.height || void 0,
    instructionsForUse: e.instructions_for_use || void 0,
    isGotsCertified: e.is_gots_certified === "yes",
    isNew: e.is_new === "yes",
    isPetRecycled: e.is_pet_recycled === "yes",
    isSoldOut: e.is_sold_out === "yes",
    isSolutionDyed: e.is_solution_dyed === "yes",
    isSolutionDyedLining: e.is_solution_dyed_lining === "yes",
    isSolutionDyedMain: e.is_solution_dyed_main === "yes",
    isVegan: e.is_vegan === "yes",
    isWaterbasedPu: e.is_waterbased_pu === "yes",
    launchDate: e.launch_date ? new Date(e.launch_date) : void 0,
    longDescription: e.long_description || void 0,
    materialDescription: e.material_description || void 0,
    model: e.model || void 0,
    modelKey: e.model_key || void 0,
    modelShort: e.model_short || void 0,
    modelSize: e.model_size || void 0,
    modelUntranslated: e.model_untranslated || void 0,
    name: e.name || void 0,
    nameUntranslated: e.name_untranslated || void 0,
    outerMaterialType: e.outer_material_type || void 0,
    pfcFree: e.pfc_free === "yes",
    releaseDate: e.release_date ? new Date(e.release_date) : void 0,
    responsibility: e.responsibility || void 0,
    restockDate: e.restock_date ? new Date(e.restock_date) : void 0,
    season: e.season || void 0,
    shortDescription: e.short_description || void 0,
    size: e.size || void 0,
    sizeUntranslated: e.size_untranslated || void 0,
    specialPrice: e.special_price || void 0,
    specialPriceFrom: e.special_price_from || void 0,
    specialPriceTo: e.special_price_to || void 0,
    style: e.style || void 0,
    styleKey: e.style_key || void 0,
    styleSwitcherColorCode: e.style_switcher_color_code || void 0,
    styleUntranslated: e.style_untranslated || void 0,
    subCategory: e.sub_category || void 0,
    themeWorld: e.theme_world || void 0,
    type: e.type || void 0,
    urlKey: e.url_key || void 0,
    vimeo: e.vimeo || void 0,
    volume: e.volume || void 0,
    weight: e.weight || void 0,
    width: e.width || void 0
  };
}, xn = (e) => ({
  additionalContent: e.additional_content,
  batteryUnNumber: e.battery_un_number,
  bluesign: e.bluesign,
  brand: e.brand,
  careInstructions: e.care_instructions,
  caseableSku: e.caseable_sku,
  catwalkVideo: e.catwalk_video,
  collection: e.collection,
  color1: e.color_1,
  color2: e.color_2,
  color3: e.color_3,
  colorCode: e.color_code,
  colors: e.colors,
  contentfulIdAdditional1: e.contentfulID_additional_1,
  contentfulIdAdditional2: e.contentfulID_additional_2,
  contentfulIdAdditional3: e.contentfulID_additional_3,
  contentfulIdContentCollection: e.contentfulID_content_collection,
  contentfulIdMaterialWidget: e.contentfulID_material_widget,
  contentfulIdProductFeatures: e.contentfulID_product_features,
  contentfulIdProductInformationGroup: e.contentfulID_product_information_group,
  contentfulIdProductModelSizeInformation: e.contentfulID_product_model_size_information,
  contentfulIdRelatedStyles: e.contentfulID_related_styles,
  contentfulIdSpecialFeature: e.contentfulID_special_feature,
  contentfulIdVideoImage: e.contentfulID_video_image,
  contentfulIdVideoPacking: e.contentfulID_video_packing,
  countryOfProduction: e.country_of_production,
  deliveryTime: e.delivery_time,
  deliveryTimeForBankpayment: e.delivery_time_for_bankpayment,
  depth: e.depth,
  ean: e.ean,
  edition: e.edition,
  editions: e.edition,
  fabric: e.fabric,
  featureDescription: e.feature_description,
  features: e.features,
  featuresHighlight: e.features_highlight,
  gender: e.gender,
  height: e.height,
  instructionsForUse: e.instructions_for_use,
  isGotsCertified: e.is_gots_certified,
  isNew: e.is_new,
  isPetRecycled: e.is_pet_recycled,
  isSoldOut: e.is_sold_out,
  isSolutionDyed: e.is_solution_dyed,
  isSolutionDyedLining: e.is_solution_dyed_lining,
  isSolutionDyedMain: e.is_solution_dyed_main,
  isVegan: e.is_vegan,
  isWaterbasedPu: e.is_waterbased_pu,
  launchDate: e.launch_date,
  longDescription: e.long_description,
  materialDescription: e.material_description,
  model: e.model,
  modelKey: e.model_key,
  modelShort: e.model_short,
  modelSize: e.model_size,
  modelUntranslated: e.model_untranslated,
  name: e.name,
  nameUntranslated: e.name_untranslated,
  outerMaterialType: e.outer_material_type,
  pfcFree: e.pfc_free,
  releaseDate: e.release_date,
  responsibility: e.responsibility,
  restockDate: e.restock_date,
  season: e.season,
  shortDescription: e.short_description,
  size: e.size,
  sizeUntranslated: e.size_untranslated,
  specialPrice: e.special_price,
  specialPriceFrom: e.special_price_from,
  specialPriceTo: e.special_price_to,
  style: e.style,
  styleKey: e.style_key,
  styleSwitcherColorCode: e.style_switcher_color_code,
  styleUntranslated: e.style_untranslated,
  subCategory: e.sub_category,
  themeWorld: e.theme_world,
  type: e.type,
  urlKey: e.url_key,
  vimeo: e.vimeo,
  volume: e.volume,
  weight: e.weight,
  width: e.width
}), Un = (e) => {
  var u;
  const t = e.attributes.model_untranslated === "Voucher" || e.superAttributes.model.includes("Voucher"), r = t, o = !!e.attributes.caseable_sku, n = oe(e.attributes.release_date), s = oe(e.attributes.restock_date), i = oe(e.attributes.launch_date), a = () => !e.price || !e.originalPrice ? e.price === 0 ? 100 : void 0 : Math.round(
    100 - e.price * 100 / e.originalPrice
  ), c = () => !!s && F(s) && !e.available || !!n && F(n) || !!i && F(i), l = () => e.price !== e.originalPrice, d = (f) => {
    if (!f)
      return !1;
    const p = new Date(f);
    return p && Gt(p, /* @__PURE__ */ new Date()) && !F(p);
  };
  return {
    name: e.name,
    sku: e.sku.replace("Abstract-", ""),
    url: e.url,
    hasBattery: !!e.attributes.battery_un_number,
    isVoucher: t,
    isDigital: r,
    isCaseable: o,
    isComingSoon: c(),
    isAvailableAtRestockDate: d(s),
    isAvailableAtLaunchDate: d(i),
    isOffer: l(),
    releaseDate: n,
    restockDate: s,
    launchDate: i,
    abstractId: e.idProductAbstract,
    abstractName: e.abstractName,
    abstractSku: e.abstractSku,
    available: e.available,
    discount: a(),
    showEdition: (!d(n) || !d(i)) && !d(s) && t,
    price: e.price,
    originalPrice: e.prices.find(
      (f) => f.priceTypeName === "ORIGINAL"
    ).grossAmount,
    currency: e.prices[0].currency,
    images: jn(e.groupedImages),
    attributes: kn(e.attributes),
    attributeNames: xn(e.attributeNames),
    categoryNodes: (u = e.categoryNodes) == null ? void 0 : u.map(Y),
    groupCount: e.groupCount ?? void 0,
    groupHash: e.groupHash ?? void 0,
    description: e.description ?? void 0,
    metaDescription: e.metaDescription ?? void 0,
    metaKeywords: e.metaKeywords ?? void 0,
    metaTitle: e.metaTitle ?? void 0
  };
}, S = (e) => {
  const t = me(
    e
  ), r = e.data[0].attributes.abstractProducts;
  return t[0].abstractProducts.map(
    (o) => Un({
      ...o,
      ...r.find(
        (n) => n.abstractSku === o.sku
      )
    })
  );
}, Ln = (e, t) => {
  const r = me(
    e
  ), [{ rangeFacets: o, valueFacets: n, pagination: s, spellingSuggestions: i }] = r;
  return {
    products: S(e),
    filter: En(n, t),
    rangeFilter: o.map(Sn),
    pagination: Mn(s),
    spellingSuggestion: i ?? void 0
  };
}, k = {
  categoryNodes: "category-nodes",
  variants: ""
}, ve = async (e, {
  relationships: t = [],
  ...r
} = {}) => {
  const o = [...new Set(e)].map((s) => [
    "sku[]",
    `Abstract-${s}`
  ]), n = await m.get("catalog-search", {
    ...r,
    searchParams: E(
      [
        "abstract-products",
        ...t.map((s) => k[s])
      ].join(","),
      r.searchParams,
      o
    ),
    deserialize: !1
  }).json();
  return S(n);
}, ls = async (e, {
  relationships: t = [],
  ...r
} = {}) => {
  const o = await m.get("catalog-search", {
    ...r,
    searchParams: E(
      [
        "abstract-products",
        ...t.map((n) => k[n])
      ].join(","),
      {
        category: String(e)
      },
      r.searchParams
    ),
    deserialize: !1
  }).json();
  return S(o);
}, ds = async (e, {
  relationships: t = [],
  ...r
} = {}) => {
  const o = await K.get("catalog-search", {
    ...r,
    searchParams: E(
      [
        "abstract-products",
        ...t.map((n) => k[n])
      ].join(","),
      r.searchParams,
      {
        category: e
      }
    ),
    deserialize: !1
  }).json();
  return S(o);
}, Wt = async (e, {
  facetBlacklist: t,
  ...r
} = {}) => {
  const o = un(e), n = await m.get("catalog-search", {
    ...r,
    searchParams: E(
      "abstract-products",
      o,
      r.searchParams
    ),
    deserialize: !1
  }).json();
  return Ln(n, t);
}, us = async (e, t, r, o = {}) => await Wt(r, {
  ...o,
  searchParams: _e(o.searchParams, t, {
    q: e
  })
}), ps = async (e, t, r = {}) => await Wt(t, {
  ...r,
  searchParams: _e(r.searchParams, {
    category: e
  })
}), zn = async (e, {
  relationships: t = [],
  ...r
} = {}) => {
  const o = await m.get("catalog-search", {
    ...r,
    searchParams: E(
      [
        "abstract-products",
        ...t.map((n) => k[n])
      ].join(","),
      e,
      r.searchParams
    ),
    deserialize: !1
  }).json();
  return S(o);
}, fs = async (e, {
  relationships: t = [],
  ...r
} = {}) => {
  const o = await m.get("catalog-search", {
    ...r,
    searchParams: E(
      [
        "abstract-products",
        ...t.map((s) => k[s]).filter((s) => !!s)
      ].join(","),
      r.searchParams,
      {
        "sku[]": `Abstract-${e}`
      }
    ),
    deserialize: !1
  }).json(), [n] = S(o);
  if (n) {
    if (t.includes("variants") && n.attributes.modelKey) {
      const s = await zn(
        {
          model_key: n.attributes.modelKey
        },
        {
          ...r,
          relationships: t
        }
      );
      return {
        ...n,
        variants: s.filter(
          (i) => i.sku !== n.sku
        )
      };
    }
    return n;
  }
}, qn = ({
  carrierName: e,
  currencyIsoCode: t,
  defaultGrossPrice: r,
  defaultNetPrice: o,
  shipmentMethodName: n
}) => ({
  carrierName: {
    NoShipment: "NoShipment",
    "Standard Shipment": "StandardShipment"
  }[e],
  currencyIsoCode: t,
  defaultGrossPrice: r,
  defaultNetPrice: o,
  shipmentMethodName: n
}), Nn = (e) => ({
  idSalesExpense: e.idSalesExpense,
  name: e.name,
  sumGrossPrice: e.sumGrossPrice,
  sumNetPrice: e.sumNetPrice,
  sumPrice: e.sumPrice,
  sumPriceToPayAggregation: e.sumPriceToPayAggregation,
  sumTaxAmount: e.sumTaxAmount,
  taxRate: e.taxRate,
  type: e.type,
  unitGrossPrice: e.unitGrossPrice,
  unitNetPrice: e.unitNetPrice,
  unitPriceToPayAggregation: e.unitPriceToPayAggregation,
  unitTaxAmount: e.unitTaxAmount,
  idShipment: e.idShipment ?? void 0,
  canceledAmount: e.canceledAmount ?? void 0,
  sumDiscountAmountAggregation: e.sumDiscountAmountAggregation ?? void 0,
  taxAmountAfterCancellation: e.taxAmountAfterCancellation ?? void 0,
  unitDiscountAmountAggregation: e.unitDiscountAmountAggregation ?? void 0
}), Bn = (e, t = []) => {
  var o;
  const r = t.find(
    (n) => n.sku === e.sku || n.sku === `Abstract-${e.sku}`
  );
  return {
    calculatedDiscounts: e.calculatedDiscounts.map(
      An
    ),
    thumbnail: e.metadata.image,
    model: (o = e.metadata.superAttributes) == null ? void 0 : o.model,
    isReturnable: e.isReturnable,
    name: e.name,
    quantity: e.quantity,
    sku: e.sku,
    state: typeof e.state == "string" ? e.state : e.state.name,
    idShipment: e.idShipment,
    product: r,
    price: e.sumPrice,
    priceToPay: e.sumPriceToPayAggregation,
    previewImageUrl: (e == null ? void 0 : e.previewImageUrl) ?? void 0,
    printjobId: (e == null ? void 0 : e.printjobId) ?? void 0
  };
}, Fn = ({
  remunerationTotal: e,
  ...t
}) => ({
  ...t,
  remunerationTotal: e ?? void 0
}), Xt = ({
  id: e,
  billingAddress: t,
  calculatedDiscounts: r,
  createdAt: o,
  currencyIsoCode: n,
  expenses: s,
  itemStates: i,
  items: a,
  payments: c,
  priceMode: l,
  shipments: d,
  shippingAddress: u,
  totals: f
}, p = []) => ({
  reference: e,
  billingAddress: j(t),
  calculatedDiscounts: Object.values(r).map(In),
  createdAt: new Date(o),
  currencyIsoCode: n,
  expenses: s.map(Nn),
  itemStates: i,
  items: a.map((h) => Bn(h, p)),
  payments: c.map(Dn),
  priceMode: l,
  shipments: d.map(qn),
  shippingAddress: j(u),
  totals: Fn(f)
});
var we = /* @__PURE__ */ ((e) => (e.IS_NEW = "new", e.ORDER_PLACED = "order placed", e.EXPORT_PENDING = "export pending", e.EXPORTED = "exported", e.PAYMENT_PENDING = "payment pending", e.PRE_AUTHORIZATION_PENDING = "pre-authorization pending", e.PRE_AUTHORIZATION_APPOINTED = "pre-authorization appointed", e.EXTERNAL_CHECKOUT = "external checkout", e.CAPTURE_PENDING = "capture pending", e.CAPTURED = "captured", e.ORDER_CONFIRMATION_SENT = "order-confirmation sent", e.THREE_D_SECURE_VERIFICATION = "3D secure verification", e.EXPORT_TO_JELLY_PENDING = "export 2 jelly pending", e.EXPORTED_TO_JELLY = "exported 2 jelly", e.GIFT_CARD_PURCHASED = "gift card purchased", e.GIFT_CARD_CREATED = "gift card created", e.CALCULATE_PROPORTIONAL_GIFT_CARD_VALUES = "calculate proportional gift card values", e.GIFT_CARD_PROPORTIONAL_VALUES_CALCULATED = "gift card proportional values calculated", e.SHIPMENT_PENDING = "shipment pending", e))(we || {}), Re = /* @__PURE__ */ ((e) => (e.SHIPPED = "shipped", e.UNDERPAID = "underpaid", e.GIFT_CARD_SHIPPED = "gift card shipped", e))(Re || {}), Pe = /* @__PURE__ */ ((e) => (e.PAID = "paid", e.CLOSED = "closed", e.DELIVERED = "delivered", e))(Pe || {}), Ie = /* @__PURE__ */ ((e) => (e.REFUND_PENDING = "refund pending", e.REFUND_APPROVAL_PENDING = "refund approval pending", e.REFUND_APPROVED = "refund approved", e.EXPORT_REFUND_TO_JELLY = "export refund to jelly", e.EXPORTED_REFUND_TO_JELLY = "exported refund to jelly", e.DEBIT_PENDING = "debit pending", e.DEBIT_APPROVAL_PENDING = "debit approval pending", e.DEBIT_APPROVED = "debit approved", e.EXPORT_DEBIT_TO_JELLY = "export debit to jelly", e.EXPORTED_DEBIT_TO_JELLY = "exported debit to jelly", e))(Ie || {}), Ae = /* @__PURE__ */ ((e) => (e.REGISTERED = "refund registered", e))(Ae || {}), De = /* @__PURE__ */ ((e) => (e.REFUNDED = "refunded", e))(De || {}), Oe = /* @__PURE__ */ ((e) => (e.DEBITED = "debited", e))(Oe || {}), Te = /* @__PURE__ */ ((e) => (e.NEW = "new", e.ORDER_PLACED = "order placed", e.TIMEOUT = "timeout", e.INVALID = "invalid", e.THREE_D_SECURE_VERIFICATION = "3D secure verification", e.EXTERNAL_CHECKOUT = "external checkout", e.ERROR = "error", e.CANCELLED = "cancelled", e))(Te || {});
const O = {
  ...we,
  ...Re,
  ...Pe,
  ...Ie,
  ...Ae,
  ...De,
  ...Oe,
  ...Te
}, $n = (e) => !(be(e) || ke(e) || Ce(e) || je(e) || Se(e) || Me(e) || Ee(e)), Jn = (e) => Object.values(Te).includes(e), Ce = (e) => Object.values(we).includes(e), be = (e) => Object.values(Pe).includes(e), Ee = (e) => Object.values(Re).includes(e), Se = (e) => Object.values(Ie).includes(e), je = (e) => Object.values(De).includes(e), Me = (e) => Object.values(Ae).includes(
  e
), ke = (e) => Object.values(Oe).includes(e), hs = (e) => Se(e) || je(e) || Me(e) || ke(e), ys = (e) => Ce(e) || be(e) || Ee(e), Hn = (e, t) => t.some($n) ? e.error : t.some(Me) ? e.refundRegistered : t.some(Se) ? e.refunding : t.some(je) ? e.refunded : t.some(ke) ? e.debited : t.some(be) ? e.closed : t.some(Ee) ? e.shipped : t.some(Ce) ? e.new : e.error, ms = (e) => Hn(
  {
    error: "error",
    closed: O.PAID,
    debited: O.DEBITED,
    new: O.IS_NEW,
    refunded: O.REFUNDED,
    refunding: O.REFUND_PENDING,
    refundRegistered: O.REGISTERED,
    shipped: O.SHIPPED
  },
  e
), gs = async (e, t = {}) => {
  const r = await m.get(`orders/${e}`, {
    ...t,
    deserialize: !0
  }).json(), o = await ve(
    r.items.map((n) => n.sku)
  );
  return Xt(r, o);
}, Vn = {
  affenzahn: "AFZ",
  ergobag: "ERG",
  satch: "SAT"
}, _s = async (e = {}) => {
  const r = (await m.get("orders", {
    ...e,
    deserialize: !0
  }).json()).filter((n) => !n.itemStates.every(Jn)).filter(
    (n) => n.id.startsWith(Vn[import.meta.env.PUBLIC_BRAND])
  ).sort((n, s) => Pn(s.createdAt, n.createdAt));
  if (r.length === 0)
    return [];
  const o = await ve(
    r.flatMap(
      (n) => n.items.map((s) => s.sku)
    )
  );
  return r.map((n) => Xt(n, o));
}, vs = async (e, t, r = {}) => {
  const o = gn(), n = await K.post("guest-cart-items", {
    ...r,
    auth: !1,
    uuid: !1,
    deserialize: !0,
    json: {
      data: {
        type: "guest-cart-items",
        attributes: {
          sku: e,
          quantity: 1
        }
      }
    },
    headers: {
      "X-Anonymous-Customer-Unique-Id": o
    }
  }).json(), s = er(t);
  return await K.post("checkout", {
    auth: !1,
    uuid: !1,
    json: {
      data: {
        type: "checkout",
        attributes: {
          customer: {
            email: t.email,
            firstName: t.firstName,
            lastName: t.lastName
          },
          idCart: n.id,
          billingAddress: s,
          shippingAddress: s,
          payments: [
            {
              paymentProviderName: "Nopayment",
              paymentMethodName: "paid"
            }
          ],
          shipment: {
            idShipmentMethod: 1
          },
          shipments: [
            {
              items: [e],
              shippingAddress: s,
              idShipmentMethod: 1,
              requestedDeliveryDate: null
            }
          ]
        }
      }
    },
    headers: {
      "X-Anonymous-Customer-Unique-Id": o
    }
  }).json();
}, Kt = (e) => ({
  email: e.email,
  id: e.id,
  type: e.type,
  relationshipNames: e.relationshipNames,
  links: e.links,
  createdAt: new Date(e.createdAt),
  updatedAt: new Date(e.updatedAt),
  registeredAt: e.registered ? new Date(e.registered) : void 0,
  firstName: e.firstName ?? void 0,
  lastName: e.lastName ?? void 0,
  gender: e.gender ?? void 0,
  salutation: e.salutation ?? void 0,
  dateOfBirth: e.dateOfBirth ? new Date(e.dateOfBirth) : void 0,
  getAddresses: async () => {
    var t;
    return e.addresses ? (t = e.addresses) == null ? void 0 : t.map(j) : await pn(e.id);
  }
}), Gn = (e) => ({
  type: "customerPasswordUpdated",
  accountExists: e.accountExists,
  updatedAt: e.updatedAt ? new Date(e.updatedAt) : void 0,
  isUpdated: e.isUpdated ?? void 0,
  links: e.links
}), Wn = (e) => ({
  type: "accessTokens",
  accessToken: e.accessToken,
  expiresIn: e.expiresIn,
  links: e.links,
  refreshToken: e.refreshToken,
  tokenType: e.tokenType
}), Xn = (e) => ({
  data: {
    type: "customer-complaints",
    attributes: {
      firstname: e.customer.firstName,
      lastname: e.customer.lastName,
      email: e.customer.email,
      zip: e.address.zipCode,
      city: e.address.city,
      country: e.address.country,
      street: e.address.street,
      housenumber: e.address.housenumber,
      productDetail: e.productDetail,
      claimReport: e.claimReport,
      claimProductType: e.claimProductType,
      claimDifferentiation: e.claimDifferentiation,
      sku: e.sku,
      shoeSize: e.shoeSize,
      recipe: e.recipe,
      product: e.product,
      purchaseDate: e.purchaseDate
    }
  }
}), ws = async (e = {}) => {
  const t = await m.get("customers", {
    throwHttpErrors: !1,
    ...e,
    deserialize: !0,
    auth: !0
  }).json();
  if (t != null && t[0])
    return Kt(t[0]);
}, Rs = async (e, t = {}) => await m.post("customer-forgotten-password", {
  auth: !1,
  ...t,
  json: {
    data: {
      type: "customer-forgotten-password",
      attributes: e
    }
  }
}), Ps = ({ email: e, ...t }, r = {}) => m.patch(
  `customer-restore-password/${t.restorePasswordKey}`,
  {
    auth: !1,
    ...r,
    json: {
      data: {
        type: "customer-restore-password",
        id: t.restorePasswordKey,
        attributes: {
          ...t,
          username: e,
          confirmPassword: t.password
        }
      }
    }
  }
), Is = async (e, t = {}) => {
  const r = await m.post("customer-password-updated", {
    auth: !0,
    ...t,
    deserialize: !0,
    json: {
      data: {
        type: "customer-password-updated",
        attributes: e
      }
    }
  }).json();
  return Gn(r);
}, As = async ({ email: e, ...t }, r = {}) => {
  const o = await m.post("access-tokens", {
    uuid: !0,
    auth: !1,
    ...r,
    deserialize: !0,
    json: {
      data: {
        type: "access-tokens",
        attributes: {
          ...t,
          username: e
        }
      }
    }
  }).json();
  return Wn(o);
}, Ds = async (e, t = {}) => {
  const r = await m.post("customers", {
    uuid: !0,
    auth: !1,
    ...t,
    deserialize: !0,
    json: {
      data: {
        type: "customers",
        attributes: {
          ...e,
          confirmPassword: e.password,
          acceptedTerms: !0,
          passwordUpdatedAt: (/* @__PURE__ */ new Date()).toISOString()
        }
      }
    }
  }).json();
  return Kt(r);
}, Os = async (e, t = {}) => await m.post("customer-confirmation", {
  auth: !1,
  ...t,
  json: {
    data: {
      type: "customer-confirmation",
      attributes: e
    }
  }
}), Ts = async (e = {}) => {
  await m.post("customer-verification-resend", {
    auth: !0,
    ...e,
    json: {
      data: {
        type: "customer-verification-resend",
        attributes: {
          resend: !0
        }
      }
    }
  });
}, Cs = (e, t = {}) => K.post(
  "customer-complaints",
  {
    ...t,
    json: Xn(e)
  }
), Kn = (e, t) => {
  const r = new FormData();
  return Object.entries(t).forEach(([o, n]) => r.append(o, n)), r.append("file", e), r;
}, Yn = async (e, t = {}) => await Vt.post("media-files", {
  ...t,
  language: !1,
  auth: !1,
  fondOfInternal: !1,
  beta: !1,
  canary: !1,
  deserialize: !0,
  json: {
    data: {
      type: "media-files",
      attributes: {
        mimeType: e
      }
    }
  }
}).json(), bs = async (e, t = {}) => {
  const r = await Yn(e.type, t);
  return await ln.post(r.presignedUrl, {
    body: Kn(e, r.fields)
  }), r;
}, Zn = (e) => {
  const t = {
    DE: "deu",
    CH: "che",
    IT: "ita"
  }, r = {
    DE: "deu2_ret_B2C",
    CH: "che_ret_B2C",
    IT: "ita_ret_B2C"
  };
  return import.meta.env.PUBLIC_CONFIG_ENV === "production" ? r[e] : t[e];
}, Qn = (e, t, r = []) => {
  const o = e[t], n = Object.values(
    r.reduce(
      (s, i) => {
        if (s[i])
          return s[i].quantity++, s;
        const a = e.items.find((c) => c.sku === i);
        return a ? {
          ...s,
          [i]: a
        } : s;
      },
      {}
    )
  );
  return {
    receiverId: Zn(o.iso2Code),
    customer: {
      email: o.email,
      reference: e.reference,
      address: {
        company: "",
        name1: `${o.firstName} ${o.lastName}`,
        name2: "",
        address1: o.address1,
        address2: "",
        address3: o.address3,
        zipCode: o.zipCode,
        city: o.city,
        phone: o.phone,
        country: o.country
      }
    },
    items: n.map((s) => {
      var i;
      return {
        name: s.name,
        quantity: s.quantity,
        weight: ((i = s.product) == null ? void 0 : i.attributes.weight) ?? 0,
        price: s.priceToPay
      };
    })
  };
}, es = (e, t) => ({
  records: e.map((r) => {
    var n;
    const o = t.find((s) => s.sku === r.sku);
    return {
      fields: {
        Bestellnummer: r.orderReference,
        Brand: import.meta.env.PUBLIC_BRAND,
        Artikelnummer: r.sku,
        Retourengrund: r.reason,
        Produktkategorien: ((n = o == null ? void 0 : o.categoryNodes) == null ? void 0 : n.map((s) => s.name)) ?? [],
        Produktbezeichnung: (o == null ? void 0 : o.name) ?? null,
        Menge: r.quantity ?? null
      }
    };
  }),
  typecast: !0
}), ts = (e) => ({
  qrCode: e.qrCode,
  returnLabel: e.returnLabel,
  orderReference: e.orderReference,
  products: e.products,
  returnId: e.id,
  qrCodeLifetime: vn(/* @__PURE__ */ new Date(), 30),
  addressType: e.addressType
}), rs = (e) => ({
  qrCode: e.qrCode,
  returnLabel: e.returnLabel,
  qrCodeLifetime: e.qrCodeLifetime ? new Date(e.qrCodeLifetime) : void 0,
  orderReference: e.orderReference,
  returnId: e.returnId,
  products: e.products,
  addressType: e.addressType
}), Es = async (e, t, r = [], o = {}) => await Vt.post("return-label", {
  ...o,
  deserialize: !0,
  json: Qn(e, t, r)
}).json(), Ss = async (e, t = {}) => {
  const r = await ve(
    e.map((n) => n.sku),
    // Return reasons should be saved in german
    {
      language: !1,
      headers: {
        "Accept-Language": "de-DE,de;q=0.9"
      },
      relationships: ["categoryNodes"]
    }
  );
  return await cn.post("return-reason", {
    ...t,
    json: es(e, r),
    auth: !0
  });
}, os = async () => {
  const e = localStorage.getItem("registered_returns");
  return e ? Object.entries(
    JSON.parse(e)
  ).reduce(
    (t, [r, o]) => ({
      ...t,
      [r]: o.map(rs)
    }),
    {}
  ) : {};
}, js = async (e) => {
  const t = await os(), r = {
    ...t,
    [e.orderReference]: [
      ...t[e.orderReference] ?? [],
      ts(e)
    ]
  };
  return localStorage.setItem(
    "registered_returns",
    JSON.stringify(r)
  ), r;
}, xe = (e) => ({
  id: e.id,
  type: e.type,
  name: e.name,
  numberOfItems: e.numberOfItems,
  createdAt: e.createdAt,
  updatedAt: e.updatedAt,
  links: e.links,
  relationshipNames: e.relationshipNames,
  wishlistItems: e.wishlistItems
}), ns = (e) => ({
  id: e.id,
  type: e.type,
  sku: e.sku
}), ss = {
  affenzahn: "default",
  satch: "satch-default",
  ergobag: "ergobag-default"
}, Yt = ss[import.meta.env.PUBLIC_BRAND], Ms = async (e = {}) => {
  const t = await m.get("wishlists", {
    throwHttpErrors: !1,
    ...e,
    deserialize: !0,
    auth: !0
  }).json(), r = t == null ? void 0 : t.find(
    (o) => o.name === Yt
  );
  return r ? xe(r) : void 0;
}, ks = async (e, t = {}) => {
  const r = await m.get(`wishlists/${e}?include=wishlist-items`, {
    throwHttpErrors: !1,
    ...t,
    deserialize: !0,
    auth: !0
  }).json();
  return xe(r);
}, xs = async (e = {}) => {
  const t = await m.post("wishlists", {
    auth: !0,
    ...e,
    deserialize: !0,
    json: {
      data: {
        type: "wishlists",
        attributes: {
          name: Yt
        }
      }
    }
  }).json();
  return xe(t);
}, Us = async (e, t, r = {}) => {
  const o = await m.post(`wishlists/${e}/wishlist-items`, {
    auth: !0,
    ...r,
    deserialize: !0,
    json: {
      data: {
        type: "wishlist-items",
        attributes: {
          sku: t
        }
      }
    }
  }).json();
  return ns(o);
}, Ls = async (e, t, r = {}) => await m.delete(
  `wishlists/${e}/wishlist-items/${t}`,
  {
    throwHttpErrors: !1,
    ...r,
    auth: !0
  }
);
export {
  O as ItemState,
  Pe as ItemStateClosed,
  Oe as ItemStateDebited,
  Te as ItemStateHidden,
  we as ItemStateNew,
  Ae as ItemStateRefundRegistered,
  De as ItemStateRefunded,
  Ie as ItemStateRefunding,
  Re as ItemStateShipped,
  xs as addWishlist,
  Us as addWishlistItem,
  Wt as baseSearchProductCatalog,
  Vt as brandApiV1Client,
  cn as brandApiV2Client,
  ps as categoryProductCatalog,
  Os as confirmRegistration,
  Cs as createCustomerComplaints,
  Yn as createMediaFile,
  Kn as createMediaFileToFormData,
  Es as createReturnLabel,
  Ss as createReturnReason,
  Ls as deleteWishlistItem,
  Rs as forgotPassword,
  Hn as getByItemStateCondition,
  as as getCategory,
  ws as getCustomer,
  pn as getCustomerAddresses,
  ms as getItemState,
  gs as getOrder,
  _s as getOrders,
  fs as getProduct,
  ve as getProducts,
  ls as getProductsByCategory,
  os as getRegisteredReturns,
  ds as getServiceProducts,
  Ms as getWishlist,
  ks as getWishlistById,
  m as glueApiClient,
  Is as hasUpdatedPassword,
  be as isItemStateClosed,
  ke as isItemStateDebited,
  $n as isItemStateError,
  Jn as isItemStateHidden,
  Ce as isItemStateNew,
  ys as isItemStateNormal,
  hs as isItemStateRefund,
  Me as isItemStateRefundRegistered,
  je as isItemStateRefunded,
  Se as isItemStateRefunding,
  Ee as isItemStateShipped,
  As as login,
  _e as mergeSearchParams,
  E as mergeSearchParamsWithIncludes,
  vs as placeServiceOrder,
  ln as plainClient,
  Ds as register,
  js as registerReturn,
  Ts as resendVerification,
  Ps as restorePassword,
  us as searchProductCatalog,
  zn as searchProducts,
  K as serviceApiClient,
  On as sortSizeFacets,
  Wn as toAccessToken,
  j as toAddress,
  er as toAddressRequestAttributes,
  In as toCalculatedDiscount,
  Y as toCategoryNode,
  Kt as toCustomer,
  Xn as toCustomerComplaintRequest,
  cs as toDiscount,
  Nn as toExpense,
  Tn as toFilter,
  En as toFilters,
  Gn as toHasUpdatedPassword,
  Bn as toItem,
  An as toItemCalculatedDiscount,
  Xt as toOrder,
  Mn as toPagination,
  Dn as toPayment,
  Un as toProduct,
  xn as toProductAttributeNames,
  kn as toProductAttributes,
  Ln as toProductCatalog,
  S as toProducts,
  Sn as toRangeFilter,
  Zn as toReceiverId,
  rs as toRegisterReturn,
  ts as toRegisterReturnRequest,
  un as toRequest,
  Qn as toReturnLabelRequest,
  es as toReturnReasonRequest,
  dn as toSearchParams,
  qn as toShipment,
  Fn as totalsResponseAttributesToTotals,
  is as updateCustomerAddress,
  bs as uploadMediaFile
};
//# sourceMappingURL=shop-api.js.map
